import { Logger, sharedRef, configureFactoryParams, useShippingProviderFactory, useBillingFactory, useCategoryFactory, useFacetFactory, useMakeOrderFactory, useUserFactory, useProductFactory, useShippingFactory, useUserBillingFactory, useUserOrderFactory, useUserShippingFactory, track } from '@vue-storefront/core';
import { computed } from '@vue/composition-api';
import { RefundMethod } from '@gemini-vsf/api-client';

var countriesList = function (countries) { return countries
    .filter(function (c) { return c.id && c.full_name_english && c.full_name_locale; })
    .map(function (c) { return ({
    id: c.id,
    label: c.full_name_locale,
    englishLabel: c.full_name_english,
    abbreviation: c.two_letter_abbreviation,
}); })
    .sort(function (a, b) { return a.label.localeCompare(b.label); }); };
var regionList = function (country) { return ((country === null || country === void 0 ? void 0 : country.available_regions) ? country.available_regions
    .filter(function (c) { return c.id && c.code && c.name; })
    .map(function (c) { return ({
    id: Number(c.id),
    label: c.name,
    abbreviation: c.code,
}); })
    .sort(function (a, b) { return a.label.localeCompare(b.label); }) : []); };
var addressGetter = {
    countriesList: countriesList,
    regionList: regionList,
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function htmlDecode(input) {
    var formatName = function () {
        try {
            var domParser = new DOMParser();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            var doc = domParser.parseFromString(input, 'text/html');
            return doc.documentElement.textContent;
        }
        catch (_a) {
            return input;
        }
    };
    var name = formatName();
    return name === 'undefined' ? '' : name;
}

var getEntityId$1 = function (category) { var _a; 
// @ts-ignore
// eslint-disable-next-line implicit-arrow-linebreak
return (category === null || category === void 0 ? void 0 : category.entityId) || (typeof (category === null || category === void 0 ? void 0 : category.uid) === 'string' && ((_a = category === null || category === void 0 ? void 0 : category.uid) === null || _a === void 0 ? void 0 : _a.split('::')[1])) || ''; };
var getSlug$2 = function (category) {
    var slug = getEntityId$1(category) !== '' ? "/c/".concat(getEntityId$1(category)) : '';
    // @ts-ignore
    var rewrites = category === null || category === void 0 ? void 0 : category.urls;
    // @ts-ignore
    if ((category === null || category === void 0 ? void 0 : category.slug) && category.slug !== '') {
        // @ts-ignore
        slug = category.slug;
    }
    else if ((rewrites === null || rewrites === void 0 ? void 0 : rewrites.length) > 0) {
        // find canonical url
        var thisRewrite = rewrites.find(function (rewrite) { return (rewrite === null || rewrite === void 0 ? void 0 : rewrite.linkRel) === 'Canonical'; });
        if ((thisRewrite === null || thisRewrite === void 0 ? void 0 : thisRewrite.urlPath) && thisRewrite.urlPath !== '') {
            slug = thisRewrite.urlPath;
        }
    }
    return slug !== '' ? "/".concat(slug.replace(/^(\/)/, '')) : '';
};
var buildCategoryTree = function (rootCategory, currentCategory, withProducts) {
    var _a;
    if (withProducts === void 0) { withProducts = false; }
    var hasChildren = Array.isArray(rootCategory.children) && rootCategory.children.length > 0;
    var isCurrent = rootCategory.uid === currentCategory;
    var label = htmlDecode(rootCategory.name);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    var slug = (_a = getSlug$2(rootCategory)) !== null && _a !== void 0 ? _a : '';
    var childrenUid = hasChildren ? rootCategory.children.reduce(function (acc, curr) { return __spreadArray(__spreadArray([], acc, true), [curr.uid], false); }, []) : [];
    var childProductCount = hasChildren
        ? rootCategory.children
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            .reduce(function (acc, curr) { return acc + curr.product_count; }, 0)
        : 0;
    var items = hasChildren
        ? rootCategory.children.filter(function (c) { return (withProducts ? c.product_count > 0 : true); }).map(function (c) { return buildCategoryTree(c, currentCategory); })
        : [];
    return {
        label: label,
        slug: slug,
        uid: __spreadArray([rootCategory.uid], childrenUid, true),
        items: items.filter(function (c) { return c.count > 0; }),
        count: childProductCount || rootCategory.product_count,
        isCurrent: isCurrent,
    };
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getTree = function (category) {
    if (!category) {
        return null;
    }
    return buildCategoryTree(category, '');
};
var getCategoryTree$1 = function (category, currentCategory, withProducts) {
    if (currentCategory === void 0) { currentCategory = ''; }
    if (withProducts === void 0) { withProducts = false; }
    return (category ? buildCategoryTree(category, currentCategory, withProducts) : null);
};
var getCategoryBreadcrumbs = function (category) {
    var breadcrumbs = [];
    if (!category) {
        return [];
    }
    if (Array.isArray(category === null || category === void 0 ? void 0 : category.breadcrumbs)) {
        breadcrumbs = category.breadcrumbs.map(function (breadcrumb) { return ({
            text: breadcrumb.category_name,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            link: getSlug$2(breadcrumb),
        }); });
    }
    breadcrumbs.push({
        text: category.name,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        link: getSlug$2(category),
    });
    return breadcrumbs;
};
var getCategoryUidFilter = function (category_uid) { return ({
    eq: category_uid,
}); };
var categoryGetters = {
    getTree: getTree,
    getBreadcrumbs: getCategoryBreadcrumbs,
    getCategoryTree: getCategoryTree$1,
    getEntityId: getEntityId$1,
    getSlug: getSlug$2,
    getCategoryUidFilter: getCategoryUidFilter,
};
var categoryGetters$1 = categoryGetters;

var getName$1 = function (product) {
    if (!product) {
        return '';
    }
    return htmlDecode(product.name);
};
var getEntityId = function (product) {
    var puid = product === null || product === void 0 ? void 0 : product.uid;
    return (typeof puid === 'string' && (puid === null || puid === void 0 ? void 0 : puid.split('::')[1])) || '';
};
var getSlug$1 = function (product, _category) {
    var slug = getEntityId(product) !== '' ? "/p/".concat(getEntityId(product)) : '';
    // @ts-ignore
    var rewrites = product === null || product === void 0 ? void 0 : product.urls;
    if ((rewrites === null || rewrites === void 0 ? void 0 : rewrites.length) > 0) {
        // find canonical url
        var thisRewrite = rewrites.find(function (rewrite) { return (rewrite === null || rewrite === void 0 ? void 0 : rewrite.linkRel) === 'Canonical'; });
        if ((thisRewrite === null || thisRewrite === void 0 ? void 0 : thisRewrite.urlPath) && thisRewrite.urlPath !== '') {
            slug = thisRewrite.urlPath;
        }
    }
    return slug !== '' ? "/".concat(slug.replace(/^(\/)/, '')) : '';
};
var getPrice$1 = function (product) {
    var regular = 0;
    var special = null;
    var priceRange = product.price_range;
    if (priceRange && priceRange.minimum_price.regular_price.value == null) {
        priceRange = product.variant_price_range;
    }
    if (priceRange) {
        regular = priceRange.minimum_price.regular_price.value;
        var final = priceRange.minimum_price.final_price.value;
        if (final < regular) {
            special = final;
        }
    }
    return {
        regular: regular,
        special: special,
    };
};
var getFinalPrice = function (product) {
    var priceRange = product.price_range;
    if (priceRange && priceRange.minimum_price.regular_price.value == null) {
        priceRange = product.variant_price_range;
    }
    if (priceRange) {
        return priceRange.minimum_price.final_price.value;
    }
    return null;
};
var getGallery = function (product) {
    var _a, _b;
    var images = [];
    if (!(product === null || product === void 0 ? void 0 : product.media_gallery) && !((_a = product === null || product === void 0 ? void 0 : product.configurable_product_options_selection) === null || _a === void 0 ? void 0 : _a.media_gallery)) {
        return images;
    }
    var selectedGallery = ((_b = product.configurable_product_options_selection) === null || _b === void 0 ? void 0 : _b.media_gallery.length) > 0
        ? product.configurable_product_options_selection.media_gallery
        : product.media_gallery;
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, selectedGallery_1 = selectedGallery; _i < selectedGallery_1.length; _i++) {
        var galleryItem = selectedGallery_1[_i];
        if (galleryItem && galleryItem.url) {
            images.push({
                small: galleryItem.url,
                normal: galleryItem.url,
                big: galleryItem.url,
                video_content: galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.video_content,
                label: (galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.label) ? galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.label : product.name,
            });
        }
    }
    return images;
};
var getProductImageAlt = function (product, imageRole) {
    if (!product) {
        return '';
    }
    if (!product[imageRole]) {
        return product.name;
    }
    var imageAlt = product.name;
    if (product[imageRole].label !== '' && product[imageRole].label !== undefined && product[imageRole].label !== null) {
        imageAlt = product[imageRole].label;
    }
    return imageAlt;
};
var getCoverImage = function (product) {
    if (!product || !product.image) {
        return null;
    }
    return product.image.url;
};
var getRolloverImage = function (product, width) {
    var _a, _b;
    if (!product || !product.rollover_image || !((_a = product === null || product === void 0 ? void 0 : product.rollover_image) === null || _a === void 0 ? void 0 : _a.url)) {
        return null;
    }
    var suffix = '?w=650&f=a';
    if (width === 0) {
        suffix = '?f=a';
    }
    else if (width > 0) {
        suffix = "?w=".concat(width, "&f=a");
    }
    return "".concat((_b = product === null || product === void 0 ? void 0 : product.rollover_image) === null || _b === void 0 ? void 0 : _b.url).concat(suffix);
};
var getProductThumbnailImage = function (product, width) {
    if (!product || !product.thumbnail || !product.thumbnail.url) {
        return null;
    }
    var suffix = '?w=650&f=a';
    if (width === 0) {
        suffix = '?f=a';
    }
    else if (width > 0) {
        suffix = "?w=".concat(width, "&f=a");
    }
    return product.thumbnail.url + suffix;
};
var getFiltered = function (products, _filters) {
    if (!products) {
        return [];
    }
    return products;
};
var getAttributes = function (products, _filterByAttributeName) {
    if (!products || !(products === null || products === void 0 ? void 0 : products.configurable_options)) {
        return {};
    }
    var attributes = {};
    var configurableOptions = products.configurable_options;
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, configurableOptions_1 = configurableOptions; _i < configurableOptions_1.length; _i++) {
        var option = configurableOptions_1[_i];
        attributes[option.attribute_code] = {
            name: option.attribute_code,
            label: option.label,
            value: option.values.map(function (value) {
                var obj = {};
                obj[value.uid] = value.label;
                return obj;
            }),
        };
    }
    return attributes;
};
var getSortedConfigurableOptions = function (product) {
    var _a;
    if (!product || !(product === null || product === void 0 ? void 0 : product.configurable_options)) {
        return [];
    }
    if ((_a = product === null || product === void 0 ? void 0 : product.configurable_product_options_selection) === null || _a === void 0 ? void 0 : _a.configurable_options) {
        return product.configurable_product_options_selection.configurable_options.sort(function (a, b) { return ((a.attribute_code > b.attribute_code) ? 1 : ((b.attribute_code > a.attribute_code) ? -1 : 0)); });
    }
    return product.configurable_options.sort(function (a, b) { return ((a.attribute_code > b.attribute_code) ? 1 : ((b.attribute_code > a.attribute_code) ? -1 : 0)); });
};
var getDescription = function (product) {
    if (!product || !(product === null || product === void 0 ? void 0 : product.description)) {
        return '';
    }
    return product.description.html;
};
var getShortDescription = function (product) {
    if (!product || !product.short_description) {
        return '';
    }
    return product.short_description.html;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getCategoryIds = function (product) {
    var categoryIds = [];
    if (!(product === null || product === void 0 ? void 0 : product.categories)) {
        return categoryIds;
    }
    return product.categories.map(function (category) { return category.uid; });
};
var getCategory = function (product, currentUrlPath) {
    if (!(product === null || product === void 0 ? void 0 : product.categories) || (product === null || product === void 0 ? void 0 : product.categories.length) === 0) {
        return null;
    }
    var categories = currentUrlPath.split('/');
    categories.pop();
    if (categories.length === 0) {
        return null;
    }
    var categoryPath = categories.join('/');
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, _a = product.categories; _i < _a.length; _i++) {
        var category = _a[_i];
        if ("/".concat(category.url_path) === categoryPath) {
            return category;
        }
    }
    return null;
};
var getCategoryNameListingPage = function (product, currentUrlPath) {
    if (!(product === null || product === void 0 ? void 0 : product.categories) || (product === null || product === void 0 ? void 0 : product.categories.length) === 0) {
        return '';
    }
    var categories = currentUrlPath.split('/');
    if (categories.length === 0) {
        return '';
    }
    var categoryPath = categories[categories.length - 1];
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, _a = product.categories; _i < _a.length; _i++) {
        var category = _a[_i];
        if ("/".concat(category.url_path) === "/".concat(categoryPath)) {
            return category.name;
        }
    }
    return '';
};
var getCategoryIdListingPage = function (product, currentUrlPath) {
    if (!(product === null || product === void 0 ? void 0 : product.categories) || (product === null || product === void 0 ? void 0 : product.categories.length) === 0) {
        return '';
    }
    var categories = currentUrlPath.split('/');
    if (categories.length === 0) {
        return '';
    }
    var categoryPath = categories[categories.length - 1];
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, _a = product.categories; _i < _a.length; _i++) {
        var category = _a[_i];
        if ("/".concat(category.url_path) === "/".concat(categoryPath)) {
            return category.uid;
        }
    }
    return '';
};
var getCategoryNameProductPage = function (product, category) {
    var categoryName = '';
    if (!product) {
        return categoryName;
    }
    if (category) {
        var categoryObj = categoryGetters$1.getBreadcrumbs(category);
        categoryName = categoryObj[categoryObj.length - 1].text;
    }
    return categoryName;
};
var getId$1 = function (product) { return product.uid; };
var getProductSku = function (product) { return product.sku; };
var getProductMerchantSku = function (product) { return product.merchant_sku; };
// @ts-ignore
// eslint-disable-next-line no-underscore-dangle
var getTypeId = function (product) { return product.__typename; };
var getFormattedPrice$4 = function (price) {
    if (price === null) {
        return null;
    }
    // TODO get correct data from api
    var locale = 'en';
    var country = 'en';
    var currency = 'USD';
    return new Intl.NumberFormat("".concat(locale, "-").concat(country), {
        style: 'currency',
        currency: currency,
    }).format(price);
};
var getBreadcrumbs$1 = function (product, category) {
    var breadcrumbs = [];
    if (!product) {
        return breadcrumbs;
    }
    if (category) {
        breadcrumbs = categoryGetters$1.getBreadcrumbs(category);
    }
    breadcrumbs.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        text: getName$1(product),
        route: {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            path: getSlug$1(product),
        },
    });
    return breadcrumbs;
};
var getProductRelatedProduct = function (product) { return (product === null || product === void 0 ? void 0 : product.related_products) || []; };
var getProductUpsellProduct = function (product) { return (product === null || product === void 0 ? void 0 : product.upsell_products) || []; };
// export const getSwatchData = (swatchData: Product['configurable_options'][0]['values'][0]['swatch_data']): string | undefined => {
var getSwatchData = function (swatchData) {
    if (!swatchData) {
        return undefined;
    }
    return swatchData;
};
var getSwatchDataHexCode = function (swatchData) {
    if (!swatchData) {
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    var sd = getSwatchData(swatchData);
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    switch (sd.__typename) {
        case 'ColorSwatchData':
        case 'AggregationOptionColorSwatchData':
            // @ts-ignore
            return sd.hex_code;
        case 'TextSwatchData':
        case 'AggregationOptionTextSwatchData':
            // @ts-ignore
            return sd.text;
        default:
            return undefined;
    }
};
var getSwatchDataThumbnail = function (swatchData) {
    if (!swatchData) {
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    var sd = getSwatchData(swatchData);
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    switch (sd.__typename) {
        case 'ImageSwatchData':
        case 'AggregationOptionImageSwatchData':
            // @ts-ignore
            return sd.thumbnail.url;
        default:
            return undefined;
    }
};
// @ts-ignore
var getListVariantSku = function (product) { return (product === null || product === void 0 ? void 0 : product.list_sku_variants) || []; };
var productGetters = {
    getAverageRating: function (_product) {
        return 0;
    },
    getTotalReviews: function (_product) {
        return 0;
    },
    getAttributes: getAttributes,
    getBreadcrumbs: getBreadcrumbs$1,
    getCategory: getCategory,
    getCategoryNameListingPage: getCategoryNameListingPage,
    getCategoryIdListingPage: getCategoryIdListingPage,
    getCategoryNameProductPage: getCategoryNameProductPage,
    getCategoryIds: getCategoryIds,
    getCoverImage: getCoverImage,
    getDescription: getDescription,
    getFiltered: getFiltered,
    getFormattedPrice: getFormattedPrice$4,
    getGallery: getGallery,
    getId: getId$1,
    getEntityId: getEntityId,
    getName: getName$1,
    getPrice: getPrice$1,
    getFinalPrice: getFinalPrice,
    getProductRelatedProduct: getProductRelatedProduct,
    getProductSku: getProductSku,
    getProductMerchantSku: getProductMerchantSku,
    getProductThumbnailImage: getProductThumbnailImage,
    getRolloverImage: getRolloverImage,
    getProductUpsellProduct: getProductUpsellProduct,
    getShortDescription: getShortDescription,
    getSlug: getSlug$1,
    getTypeId: getTypeId,
    getSwatchData: getSwatchData,
    getSwatchDataHexCode: getSwatchDataHexCode,
    getSwatchDataThumbnail: getSwatchDataThumbnail,
    getListVariantSku: getListVariantSku,
    getSortedConfigurableOptions: getSortedConfigurableOptions,
    getProductImageAlt: getProductImageAlt,
};
var productGetters$1 = productGetters;

var getItems$3 = function (cart) {
    if (!cart || !cart.items) {
        return [];
    }
    return cart.items;
};
// eslint-disable-next-line import/no-named-as-default-member
var getItemName$2 = function (product) { return productGetters$1.getName(product.product); };
// eslint-disable-next-line import/no-named-as-default-member
var getSlug = function (product) { return productGetters$1.getSlug(product.product); };
// eslint-disable-next-line import/no-named-as-default-member
var getItemImage$1 = function (product) { return productGetters$1.getProductThumbnailImage(product.product); };
var getItemPrice$2 = function (product) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (!product || !product.prices) {
        return {
            regular: 0,
            special: 0,
        };
    }
    if (product.prices) {
        return {
            regular: ((_a = product.prices.row_regular_total) === null || _a === void 0 ? void 0 : _a.value) || 0,
            special: ((_b = product.prices.row_total) === null || _b === void 0 ? void 0 : _b.value) || 0,
        };
    }
    var regularPrice = (_f = (_e = (_d = (_c = product.product) === null || _c === void 0 ? void 0 : _c.price_range) === null || _d === void 0 ? void 0 : _d.minimum_price) === null || _e === void 0 ? void 0 : _e.regular_price) === null || _f === void 0 ? void 0 : _f.value;
    var specialPrice = (_k = (_j = (_h = (_g = product.product) === null || _g === void 0 ? void 0 : _g.price_range) === null || _h === void 0 ? void 0 : _h.minimum_price) === null || _j === void 0 ? void 0 : _j.final_price) === null || _k === void 0 ? void 0 : _k.value;
    return {
        regular: regularPrice || 0,
        special: specialPrice || 0,
        // @ts-ignore
        credit: Math.round(specialPrice / 10),
        // @TODO: Who set this installment value?
        installment: Math.round((specialPrice * 1.1046) / 10),
        discountPercentage: 100 - Math.round((specialPrice / regularPrice) * 100),
        total: (_m = (_l = product.prices) === null || _l === void 0 ? void 0 : _l.row_total) === null || _m === void 0 ? void 0 : _m.value,
    };
};
var productHasSpecialPrice = function (product) { return getItemPrice$2(product).regular > getItemPrice$2(product).special; };
var getItemQty$2 = function (product) { return product.quantity; };
var getItemAttributes$1 = function (_a, _filterByAttributeName) {
    var product = _a.product;
    var attributes = {};
    if (!product || !product.configurable_options) {
        return attributes;
    }
    var configurableOptions = product.configurable_options;
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, configurableOptions_1 = configurableOptions; _i < configurableOptions_1.length; _i++) {
        var option = configurableOptions_1[_i];
        attributes[option.attribute_code] = {
            name: option.attribute_code,
            label: option.label,
            value: option.values.map(function (value) {
                var obj = {};
                obj[value.uid] = value.label;
                return obj;
            }),
        };
    }
    return attributes;
};
var getItemSku$2 = function (product) { var _a; return ((_a = product === null || product === void 0 ? void 0 : product.product) === null || _a === void 0 ? void 0 : _a.merchant_sku) || ''; };
var calculateDiscounts = function (discounts) { return discounts.reduce(function (a, b) { return Number.parseFloat("".concat(a)) + Number.parseFloat("".concat(b.amount.value)); }, 0); };
var getTotals$1 = function (cart) {
    if (!cart || !cart.prices)
        return {};
    var subtotal = cart.prices.subtotal_including_tax.value;
    return {
        total: cart.prices.grand_total.value,
        subtotal: cart.prices.subtotal_including_tax.value,
        special: cart.prices.discounts ? subtotal - calculateDiscounts(cart.prices.discounts) : subtotal,
    };
};
var getShippingPrice$1 = function (cart) {
    if (!cart.shipping_addresses) {
        return 0;
    }
    return cart.shipping_addresses.reduce(function (acc, shippingAddress) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var selected_shipping_method = shippingAddress.selected_shipping_method;
        if (selected_shipping_method) {
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            return acc + selected_shipping_method.amount.value;
        }
        return acc;
    }, 0);
};
var getTotalItems$1 = function (cart) {
    if (!cart) {
        return 0;
    }
    return cart.total_quantity;
};
// eslint-disable-next-line import/no-named-as-default-member
var getFormattedPrice$3 = function (price) { return productGetters$1.getFormattedPrice(price); };
var getCoupons = function (cart) { return (Array.isArray(cart === null || cart === void 0 ? void 0 : cart.applied_coupons)
    ? cart.applied_coupons.map(function (c) { return ({
        id: c.code,
        name: c.code,
        value: 0,
        code: c.code,
    }); })
    : []); };
var getDiscounts = function (cart) { return (Array.isArray(cart === null || cart === void 0 ? void 0 : cart.prices.discounts)
    ? cart.prices.discounts.map(function (d) { return ({
        id: d.label,
        name: d.label,
        description: '',
        value: d.amount.value,
        code: d.label,
    }); })
    : []); };
var getAppliedCoupon = function (cart) { return (Array.isArray(cart === null || cart === void 0 ? void 0 : cart.applied_coupons) && (cart === null || cart === void 0 ? void 0 : cart.applied_coupons.length) > 0
    ? {
        id: cart.applied_coupons[0].code,
        name: cart.applied_coupons[0].code,
        value: 0,
        code: cart.applied_coupons[0].code,
    }
    : null); };
var getSelectedShippingMethod = function (cart) {
    var _a;
    var sAddrs = cart === null || cart === void 0 ? void 0 : cart.shipping_addresses;
    return ((sAddrs === null || sAddrs === void 0 ? void 0 : sAddrs.length) > 0 ? (_a = sAddrs[0]) === null || _a === void 0 ? void 0 : _a.selected_shipping_method : null);
};
var getAvailablePaymentMethods = function (cart) { return cart === null || cart === void 0 ? void 0 : cart.available_payment_methods.map(function (p) { return ({
    label: p.label,
    value: p.code,
}); }); };
var cartGetters = {
    getAppliedCoupon: getAppliedCoupon,
    getAvailablePaymentMethods: getAvailablePaymentMethods,
    getCoupons: getCoupons,
    getDiscounts: getDiscounts,
    getFormattedPrice: getFormattedPrice$3,
    getItemAttributes: getItemAttributes$1,
    getItemImage: getItemImage$1,
    getItemName: getItemName$2,
    getSlug: getSlug,
    getItemPrice: getItemPrice$2,
    getItemQty: getItemQty$2,
    getItems: getItems$3,
    getItemSku: getItemSku$2,
    getSelectedShippingMethod: getSelectedShippingMethod,
    getShippingPrice: getShippingPrice$1,
    getTotalItems: getTotalItems$1,
    getTotals: getTotals$1,
    productHasSpecialPrice: productHasSpecialPrice,
};
var cartGetters$1 = cartGetters;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getShippingMethodId = function (shippingMethod) { return ''; };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getShippingMethodName = function (shippingMethod) { return ''; };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getShippingMethodDescription = function (shippingMethod) { return ''; };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getShippingMethodPrice = function (shippingMethod) { return 0; };
// eslint-disable-next-line import/no-named-as-default-member
var getFormattedPrice$2 = function (price) { return productGetters$1.getFormattedPrice(price); };
var checkoutGetters = {
    getShippingMethodId: getShippingMethodId,
    getShippingMethodName: getShippingMethodName,
    getShippingMethodDescription: getShippingMethodDescription,
    getFormattedPrice: getFormattedPrice$2,
    getShippingMethodPrice: getShippingMethodPrice,
};
var checkoutGetters$1 = checkoutGetters;

var filterFacets = function (criteria) { return function (f) { return (criteria ? criteria.includes(f.attribute_code) : true); }; };
var getFacetTypeByCode = function (code) {
    if (code === 'type_of_stones') {
        return 'radio';
    }
    return 'checkbox';
};
var createFacetsFromOptions = function (facets, filters, facet) {
    var options = facet.options || [];
    var selectedList = filters && filters[facet.attribute_code] ? filters[facet.attribute_code] : [];
    return options
        .map(function (_a) {
        var label = _a.label, value = _a.value, count = _a.count, swatches = _a.swatches;
        return ({
            type: getFacetTypeByCode(facet.attribute_code),
            id: label,
            attrName: label,
            value: value,
            selected: selectedList.includes(value),
            count: count,
            swatch_data: Array.isArray(swatches) && swatches.length > 0 && swatches[0],
        });
    });
};
var reduceForFacets = function (facets, filters) { return function (prev, curr) { return (__spreadArray(__spreadArray([], prev, true), createFacetsFromOptions(facets, filters, curr), true)); }; };
var reduceForGroupedFacets = function (facets, filters) { return function (prev, curr) { return (__spreadArray(__spreadArray([], prev, true), [
    {
        id: curr.attribute_code,
        label: curr.label,
        options: createFacetsFromOptions(facets, filters, curr),
        count: null,
    },
], false)); }; };
var buildFacets = function (searchData, reduceFn, criteria) {
    if (!searchData.data) {
        return [];
    }
    var facets = searchData.data.availableFilters, filters = searchData.input.filters;
    return facets === null || facets === void 0 ? void 0 : facets.filter(filterFacets(criteria)).reduce(reduceFn(facets, filters), []);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getAll = function (searchData, criteria) { return buildFacets(searchData, reduceForFacets, criteria); };
// eslint-disable-next-line
var getGrouped = function (searchData, criteria) {
    var _a;
    return (_a = buildFacets(searchData, reduceForGroupedFacets, criteria)) === null || _a === void 0 ? void 0 : _a.filter(function (facet) { return facet.options && facet.options.length > 0; });
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getSortOptions = function (searchData) {
    if (!searchData || !searchData.data || !searchData.data.availableSortingOptions) {
        return {
            options: [],
            selected: '',
        };
    }
    return {
        options: searchData.data.availableSortingOptions,
        selected: searchData.input.sort,
    };
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getCategoryTree = function (searchData) {
    var buildTree = function (category) { return ({
        label: category.name,
        slug: category.url_path,
        items: (category.children) ? category.children.map(function (element) { return buildTree(element); }) : [],
        isCurrent: (category.name === searchData.data.category.name),
    }); };
    if (!searchData.data || !searchData.data.category.children) {
        return {};
    }
    return buildTree(searchData.data.category);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getProducts = function (searchData) {
    if (!searchData || !searchData.data || !searchData.data.items) {
        return [];
    }
    return searchData.data.items;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getPagination$1 = function (searchData) {
    var _a, _b, _c, _d;
    var totalPages = (searchData === null || searchData === void 0 ? void 0 : searchData.data) ? (Number.isNaN(Math.ceil(searchData.data.total / searchData.input.itemsPerPage))
        ? 1
        : Math.ceil(searchData.data.total / searchData.input.itemsPerPage)) : 1;
    return {
        currentPage: (((_a = searchData === null || searchData === void 0 ? void 0 : searchData.input) === null || _a === void 0 ? void 0 : _a.page) > totalPages ? 1 : (_b = searchData === null || searchData === void 0 ? void 0 : searchData.input) === null || _b === void 0 ? void 0 : _b.page) || 1,
        totalPages: totalPages,
        totalItems: ((_c = searchData === null || searchData === void 0 ? void 0 : searchData.data) === null || _c === void 0 ? void 0 : _c.total) ? searchData.data.total : 0,
        itemsPerPage: ((_d = searchData === null || searchData === void 0 ? void 0 : searchData.input) === null || _d === void 0 ? void 0 : _d.itemsPerPage) || 10,
        pageOptions: [10, 50, 100],
    };
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getBreadcrumbs = function (searchData) { return []; };
var facetGetters = {
    getSortOptions: getSortOptions,
    getGrouped: getGrouped,
    getAll: getAll,
    getProducts: getProducts,
    getCategoryTree: getCategoryTree,
    getBreadcrumbs: getBreadcrumbs,
    getPagination: getPagination$1,
};
var facetGetters$1 = facetGetters;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getResetPasswordToken(result) {
    return '';
}
var isPasswordChanged = function (result) { return result === null || result === void 0 ? void 0 : result.resetPassword; };
var forgotPasswordGetters = {
    getResetPasswordToken: getResetPasswordToken,
    isPasswordChanged: isPasswordChanged,
};
var forgotPasswordGetters$1 = forgotPasswordGetters;

/* istanbul ignore file */
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
var getDate = function (order) { return new Date(order === null || order === void 0 ? void 0 : order.order_date).toLocaleDateString() || ''; };
var getOrderFormattedDate = function (order) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    var dateToConvert = new Date(order === null || order === void 0 ? void 0 : order.order_date);
    return "".concat(dateToConvert.getUTCFullYear(), "-").concat(dateToConvert.getUTCMonth() + 1, "-").concat(dateToConvert.getUTCDate(), " ").concat(dateToConvert.getUTCHours(), ":").concat(dateToConvert.getUTCMinutes(), ":").concat(dateToConvert.getUTCSeconds());
};
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
var getId = function (order) { return (order === null || order === void 0 ? void 0 : order.number) || ''; };
var getStatus = function (order) { return (order === null || order === void 0 ? void 0 : order.status) || 'Failed'; };
var getPrice = function (order) { return (order === null || order === void 0 ? void 0 : order.total.grand_total.value) || -1; };
var getItems$2 = function (order) { return (order === null || order === void 0 ? void 0 : order.items) || []; };
var getItemSku$1 = function (item) { return (item === null || item === void 0 ? void 0 : item.product_sku) || 0; };
var getItemName$1 = function (item) { return (item === null || item === void 0 ? void 0 : item.product_name) || 0; };
var getItemQty$1 = function (item) { return (item === null || item === void 0 ? void 0 : item.quantity_ordered) || 0; };
var getItemPrice$1 = function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.product_sale_price) === null || _a === void 0 ? void 0 : _a.value) || 0; };
var getFormattedPrice$1 = function (price) { return String(price); };
var getPagination = function (orders) {
    var _a, _b, _c;
    return ({
        currentPage: ((_a = orders === null || orders === void 0 ? void 0 : orders.page_info) === null || _a === void 0 ? void 0 : _a.current_page) || 1,
        totalPages: ((_b = orders === null || orders === void 0 ? void 0 : orders.page_info) === null || _b === void 0 ? void 0 : _b.total_pages) || 1,
        totalItems: (orders === null || orders === void 0 ? void 0 : orders.total_count) || 0,
        itemsPerPage: ((_c = orders === null || orders === void 0 ? void 0 : orders.page_info) === null || _c === void 0 ? void 0 : _c.page_size) || 10,
        pageOptions: [10, 50, 100],
    });
};
var orderGetters = {
    getDate: getDate,
    getOrderFormattedDate: getOrderFormattedDate,
    getId: getId,
    getStatus: getStatus,
    getPrice: getPrice,
    getItems: getItems$2,
    getItemSku: getItemSku$1,
    getItemName: getItemName$1,
    getItemQty: getItemQty$1,
    getItemPrice: getItemPrice$1,
    getFormattedPrice: getFormattedPrice$1,
    getPagination: getPagination,
};
var orderGetters$1 = orderGetters;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getItems$1(stores, criteria) {
    return stores;
}
function getSelected(config, store) {
    return config.store_code === store.store_code;
}
var storeGetters = {
    getItems: getItems$1,
    getSelected: getSelected,
};
var storeGetters$1 = storeGetters;

var transformUserCreateAddressInput = function (addressInputParams) {
    var _a = addressInputParams.address, apartment = _a.apartment, neighborhood = _a.neighborhood, extra = _a.extra, address = __rest(_a, ["apartment", "neighborhood", "extra"]);
    var street = [address.street];
    if (apartment)
        street.push(apartment);
    if (neighborhood)
        street.push(neighborhood);
    if (extra)
        street.push(extra);
    return __assign(__assign({}, address), { street: street });
};
var transformUserUpdateAddressInput = function (addressInputParams) {
    var _a = addressInputParams.address, apartment = _a.apartment, neighborhood = _a.neighborhood, extra = _a.extra, id = _a.id; 
    // @ts-ignore
    // eslint-disable-next-line
    _a.extension_attributes; 
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    _a.__typename; var address = __rest(_a, ["apartment", "neighborhood", "extra", "id", "extension_attributes", "__typename"]);
    var _b = address.region; 
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    _b.__typename; var region = __rest(_b, ["__typename"]);
    var street = (Array.isArray(address.street) ? __spreadArray([], address.street, true) : [address.street]);
    if (apartment)
        street.push(apartment);
    if (neighborhood)
        street.push(neighborhood);
    if (extra)
        street.push(extra);
    var addressParams = __assign(__assign({}, address), { region: region, street: street.filter(Boolean) });
    return {
        addressId: id,
        input: __assign({}, addressParams),
    };
};
var transformUserGetter = function (addressInput) { return (__assign(__assign({}, addressInput), { street: addressInput.street[0], apartment: addressInput.street[1], neighborhood: addressInput.street[2], extra: addressInput.street[3] })); };

var userAddressesGetters = {
    getAddresses: function (addresses, criteria) {
        var _a, _b;
        if (!addresses || addresses.length === 0 || !Array.isArray(addresses))
            return [];
        var addressesData = (_b = (_a = addresses === null || addresses === void 0 ? void 0 : addresses.map(function (a) { return transformUserGetter(a); })) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) { return ((a.default_shipping === b.default_shipping) ? 0 : (a.default_shipping ? -1 : 1)); })) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) { return ((a.default_billing === b.default_billing) ? 0 : (a.default_billing ? -1 : 1)); });
        if (!criteria || Object.keys(criteria).length === 0) {
            return addressesData;
        }
        var entries = Object.entries(criteria);
        return addressesData.filter(function (address) { return entries.every(function (_a) {
            var key = _a[0], value = _a[1];
            return address[key] === value;
        }); });
    },
    getDefault: function (addresses) { return addresses.find(function (_a) {
        var isDefault = _a.isDefault;
        return isDefault;
    }); },
    getTotal: function (addresses) { return addresses.length; },
    getPostCode: function (address) { return (address === null || address === void 0 ? void 0 : address.postcode) || ''; },
    getStreetName: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[0] : address === null || address === void 0 ? void 0 : address.street); },
    getStreetNumber: function (address) { return (address === null || address === void 0 ? void 0 : address.streetNumber) || ''; },
    getCity: function (address) { return (address === null || address === void 0 ? void 0 : address.city) || ''; },
    getFirstName: function (address) { return (address === null || address === void 0 ? void 0 : address.firstname) || ''; },
    getLastName: function (address) { return (address === null || address === void 0 ? void 0 : address.lastname) || ''; },
    getCountry: function (address) { return (address === null || address === void 0 ? void 0 : address.country_code) || ''; },
    getPhone: function (address) { return (address === null || address === void 0 ? void 0 : address.phone) || ''; },
    getEmail: function (address) { return (address === null || address === void 0 ? void 0 : address.email) || ''; },
    getProvince: function (address) { var _a, _b; return (((_a = address === null || address === void 0 ? void 0 : address.region) === null || _a === void 0 ? void 0 : _a.region_code) || ((_b = address === null || address === void 0 ? void 0 : address.region) === null || _b === void 0 ? void 0 : _b.region)) || ''; },
    getCompanyName: function (address) { return (address === null || address === void 0 ? void 0 : address.company) || ''; },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTaxNumber: function (address) { return (address === null || address === void 0 ? void 0 : address.vat_id) || ''; },
    getId: function (address) { return (address === null || address === void 0 ? void 0 : address.id) || ''; },
    getApartmentNumber: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[1] : address === null || address === void 0 ? void 0 : address.apartment); },
    getNeighborhood: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[2] : address === null || address === void 0 ? void 0 : address.neighborhood); },
    getAddressExtra: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[3] : address === null || address === void 0 ? void 0 : address.extra); },
    isDefault: function (address) { return ((address === null || address === void 0 ? void 0 : address.default_shipping) || (address === null || address === void 0 ? void 0 : address.default_billing)) || false; },
    isDefaultShipping: function (address) { return (address === null || address === void 0 ? void 0 : address.default_shipping) || false; },
    isDefaultBilling: function (address) { return (address === null || address === void 0 ? void 0 : address.default_billing) || false; },
};
var userAddressesGetters$1 = userAddressesGetters;

var userBillingGetters = {
    getAddresses: function (billing, criteria) {
        if (!criteria || Object.keys(criteria).length === 0) {
            return billing.addresses;
        }
        var entries = Object.entries(criteria);
        return billing.addresses.filter(function (address) { return entries.every(function (_a) {
            var key = _a[0], value = _a[1];
            return address[key] === value;
        }); });
    },
    getDefault: function (billing) { return billing.addresses.find(function (_a) {
        var isDefault = _a.isDefault;
        return isDefault;
    }); },
    getTotal: function (billing) { return billing.addresses.length; },
    getPostCode: function (address) { return (address === null || address === void 0 ? void 0 : address.postcode) || ''; },
    getStreetName: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[0] : ''); },
    getStreetNumber: function (address) { return (address === null || address === void 0 ? void 0 : address.streetNumber) || ''; },
    getCity: function (address) { return (address === null || address === void 0 ? void 0 : address.city) || ''; },
    getFirstName: function (address) { return (address === null || address === void 0 ? void 0 : address.firstname) || ''; },
    getLastName: function (address) { return (address === null || address === void 0 ? void 0 : address.lastname) || ''; },
    getCountry: function (address) { return (address === null || address === void 0 ? void 0 : address.country_code) || ''; },
    getPhone: function (address) { return (address === null || address === void 0 ? void 0 : address.phone) || ''; },
    getEmail: function (address) { return (address === null || address === void 0 ? void 0 : address.email) || ''; },
    getProvince: function (address) { var _a, _b; return (((_a = address === null || address === void 0 ? void 0 : address.region) === null || _a === void 0 ? void 0 : _a.region_code) || ((_b = address === null || address === void 0 ? void 0 : address.region) === null || _b === void 0 ? void 0 : _b.region)) || ''; },
    getCompanyName: function (address) { return (address === null || address === void 0 ? void 0 : address.company) || ''; },
    getNeighborhood: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[2] : address === null || address === void 0 ? void 0 : address.neighborhood); },
    getAddressExtra: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[3] : address === null || address === void 0 ? void 0 : address.extra); },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTaxNumber: function (address) { return address.vat_id || ''; },
    getId: function (address) { return (address === null || address === void 0 ? void 0 : address.id) || ''; },
    getApartmentNumber: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[1] : ''); },
    isDefault: function (address) { return (address === null || address === void 0 ? void 0 : address.default_billing) || false; },
};
var userBillingGetters$1 = userBillingGetters;

var getFirstName = function (user) { return (user ? user.firstname : ''); };
var getLastName = function (user) { return (user ? user.lastname : ''); };
var getEmailAddress = function (user) { return (user ? user.email : ''); };
var getFullName = function (user) { return (user ? "".concat(user.firstname, " ").concat(user.lastname) : ''); };
var userGetters = {
    getFirstName: getFirstName,
    getLastName: getLastName,
    getEmailAddress: getEmailAddress,
    getFullName: getFullName,
};
var userGetters$1 = userGetters;

var userShippingGetters = {
    getAddresses: function (shipping, criteria) {
        Logger.debug(shipping);
        if (!shipping || !shipping.addresses)
            return [];
        if (!criteria || Object.keys(criteria).length === 0) {
            return shipping.addresses;
        }
        var entries = Object.entries(criteria);
        return shipping.addresses.filter(function (address) { return entries.every(function (_a) {
            var key = _a[0], value = _a[1];
            return address[key] === value;
        }); });
    },
    getDefault: function (shipping) { return shipping.addresses.find(function (_a) {
        var isDefault = _a.isDefault;
        return isDefault;
    }); },
    getTotal: function (shipping) { return shipping.addresses.length; },
    getPostCode: function (address) { return (address === null || address === void 0 ? void 0 : address.postcode) || ''; },
    getStreetName: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[0] : ''); },
    getStreetNumber: function (address) { return (address === null || address === void 0 ? void 0 : address.streetNumber) || ''; },
    getCity: function (address) { return (address === null || address === void 0 ? void 0 : address.city) || ''; },
    getFirstName: function (address) { return (address === null || address === void 0 ? void 0 : address.firstname) || ''; },
    getLastName: function (address) { return (address === null || address === void 0 ? void 0 : address.lastname) || ''; },
    getCountry: function (address) { return (address === null || address === void 0 ? void 0 : address.country_code) || ''; },
    getPhone: function (address) { return (address === null || address === void 0 ? void 0 : address.phone) || ''; },
    getEmail: function (address) { return (address === null || address === void 0 ? void 0 : address.email) || ''; },
    getProvince: function (address) { var _a, _b; return (((_a = address === null || address === void 0 ? void 0 : address.region) === null || _a === void 0 ? void 0 : _a.region_code) || ((_b = address === null || address === void 0 ? void 0 : address.region) === null || _b === void 0 ? void 0 : _b.region)) || ''; },
    getCompanyName: function (address) { return (address === null || address === void 0 ? void 0 : address.company) || ''; },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTaxNumber: function (address) { return ''; },
    getId: function (address) { return (address === null || address === void 0 ? void 0 : address.id) || ''; },
    getApartmentNumber: function (address) { return (Array.isArray(address === null || address === void 0 ? void 0 : address.street) ? address === null || address === void 0 ? void 0 : address.street[1] : ''); },
    isDefault: function (address) { return (address === null || address === void 0 ? void 0 : address.default_shipping) || false; },
};
var userShippingGetters$1 = userShippingGetters;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getItems = function (wishlist) { var _a, _b; return (_b = (_a = wishlist === null || wishlist === void 0 ? void 0 : wishlist.items) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []; };
var getItemName = function (wishlistItem) { var _a; return ((_a = wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product) === null || _a === void 0 ? void 0 : _a.name) || ''; };
var getItemImage = function (wishlistItem) { return getProductThumbnailImage(wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product) || ''; };
var getItemPrice = function (wishlistItem) { return ({
    regular: getPrice$1(wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product).regular,
    special: getPrice$1(wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product).special,
}); };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getItemQty = function (wishlistItem) { return wishlistItem.qty; };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getItemAttributes = function (wishlistItem, filterByAttributeName) { return ({ '': '' }); };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getItemSku = function (wishlistItem) { var _a; return ((_a = wishlistItem === null || wishlistItem === void 0 ? void 0 : wishlistItem.product) === null || _a === void 0 ? void 0 : _a.merchant_sku) || ''; };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getTotals = function (wishlist) {
    var _a;
    return ((_a = wishlist === null || wishlist === void 0 ? void 0 : wishlist.items) === null || _a === void 0 ? void 0 : _a.items.reduce(function (acc, curr) { return ({
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-unsafe-argument
        total: acc.total + getItemPrice(curr).special,
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/no-unsafe-argument
        subtotal: acc.subtotal + getItemPrice(curr).regular,
    }); }, ({ total: 0, subtotal: 0 })));
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getShippingPrice = function (wishlist) { return 0; };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getTotalItems = function (wishlist) { var _a; return (Array.isArray(wishlist) ? (_a = wishlist[0]) === null || _a === void 0 ? void 0 : _a.items_count : ((wishlist === null || wishlist === void 0 ? void 0 : wishlist.items_count) || 0)); };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getFormattedPrice = function (price) { return ''; };
var wishlistGetters = {
    getTotals: getTotals,
    getShippingPrice: getShippingPrice,
    getItems: getItems,
    getItemName: getItemName,
    getItemImage: getItemImage,
    getItemPrice: getItemPrice,
    getItemQty: getItemQty,
    getItemAttributes: getItemAttributes,
    getItemSku: getItemSku,
    getTotalItems: getTotalItems,
    getFormattedPrice: getFormattedPrice,
    // getPagination,
};
var wishlistGetters$1 = wishlistGetters;

var getCode = function (config) { return config.store_code; };
var getTitle$1 = function (config) { return config.default_title; };
var getName = function (config) { return config.store_name; };
var getCurrency = function (config) { return config.default_display_currency_code; };
var getLocale = function (config) { return config.locale; };
var allowGuestProductReview = function (config) { return config.allow_guests_to_write_product_reviews; };
var enabledWishlist = function (config) { return config.gemini_wishlist_general_is_enabled; };
var storeConfigGetters = {
    getCode: getCode,
    getTitle: getTitle$1,
    getName: getName,
    getCurrency: getCurrency,
    getLocale: getLocale,
    allowGuestProductReview: allowGuestProductReview,
    enabledWishlist: enabledWishlist,
};
var StoreConfigGetters = storeConfigGetters;

var getIdentifier = function (item) { return item.identifier || ''; };
var getContent = function (item) { return item.content || ''; };
var getMetaTitle = function (item) { return item.meta_title || ''; };
var getMetaDescription = function (item) { return item.meta_description || ''; };
var getContentHeading = function (item) { return item.content_heading || ''; };
var getTitle = function (item) { return item.title || ''; };
// cms
var getCmsBlockContent = function (items) { return items.reduce(function (prev, item) {
    try {
        prev[item.identifier] = JSON.parse(item.content);
    }
    catch (error) {
        prev[item.identifier] = null;
    }
    return prev;
}, {}); };
var contentGetters = {
    getIdentifier: getIdentifier,
    getContent: getContent,
    getMetaTitle: getMetaTitle,
    getMetaDescription: getMetaDescription,
    getContentHeading: getContentHeading,
    getTitle: getTitle,
    getCmsBlockContent: getCmsBlockContent,
};
var contentGetters$1 = contentGetters;

var getContextProperty = function (object, name) { return ((object === null || object === void 0 ? void 0 : object["$".concat(name)])
    || (object === null || object === void 0 ? void 0 : object[name])); };

var extendScopeContext = function (scope, app) {
    // @ts-ignore
    if (scope.vm) {
        // @ts-ignore
        scope.vm.interceptors = getContextProperty(app, 'interceptors');
        // @ts-ignore
        scope.vm.i18n = getContextProperty(app, 'i18n');
        // @ts-ignore
        scope.vm.routing = getContextProperty(app, 'routing');
        // @ts-ignore
        scope.vm.gemini = getContextProperty(app, 'gemini');
    }
};

var useAddressesFactory = function (factoryParams) { return function useAddresses() {
    var _this = this;
    var loading = sharedRef(false, 'useAddresses-loading');
    var addresses = sharedRef(null, 'useAddresses-shipping');
    var error = sharedRef({
        load: null,
        save: null,
        remove: null,
        update: null,
    }, 'useAddresses-error');
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    var load = function (loadParams) { return __awaiter(_this, void 0, void 0, function () {
        var addressesInfo, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('useAddresses.load');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.load(loadParams)];
                case 2:
                    addressesInfo = _a.sent();
                    error.value.load = null;
                    addresses.value = addressesInfo;
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    error.value.load = err_1;
                    Logger.error('useAddresses/load', err_1);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var save = function (saveParams) { return __awaiter(_this, void 0, void 0, function () {
        var addressesInfo, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('useAddresses.save');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.save(saveParams)];
                case 2:
                    addressesInfo = _a.sent();
                    error.value.save = null;
                    addresses.value = addressesInfo;
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    error.value.save = err_2;
                    Logger.error('useAddresses/save', err_2);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var update = function (updateParams) { return __awaiter(_this, void 0, void 0, function () {
        var addressesInfo, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('useAddresses.update');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.update(updateParams)];
                case 2:
                    addressesInfo = _a.sent();
                    error.value.update = null;
                    addresses.value = addressesInfo;
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _a.sent();
                    error.value.update = err_3;
                    Logger.error('useAddresses.delete', err_3);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var remove = function (removeParams) { return __awaiter(_this, void 0, void 0, function () {
        var err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('useAddresses.remove');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.remove(removeParams)];
                case 2:
                    _a.sent();
                    error.value.remove = null;
                    return [3 /*break*/, 5];
                case 3:
                    err_4 = _a.sent();
                    error.value.remove = err_4;
                    Logger.error('useAddresses.remove', err_4);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        addresses: computed(function () { return addresses.value; }),
        error: computed(function () { return error.value; }),
        load: load,
        loading: computed(function () { return loading.value; }),
        remove: remove,
        save: save,
        update: update,
    };
}; };

var factoryParams$v = {
    load: function (context, _params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] load user addresses');
                    return [4 /*yield*/, context.$gemini.api.getCustomerAddresses()];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, (_a = data.customer.addresses) !== null && _a !== void 0 ? _a : []];
            }
        });
    }); },
    save: function (context, saveParams) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] save user address:', saveParams.address);
                    return [4 /*yield*/, context.$gemini.api.createCustomerAddress(transformUserCreateAddressInput(saveParams))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data.createCustomerAddress) !== null && _a !== void 0 ? _a : { id: null }];
            }
        });
    }); },
    remove: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini] remove user addresses');
                    return [4 /*yield*/, context.$gemini.api.deleteCustomerAddress(params.address.id)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, !!data.deleteCustomerAddress];
            }
        });
    }); },
    update: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] update user addresses', params);
                    return [4 /*yield*/, context.$gemini.api.updateCustomerAddress(transformUserUpdateAddressInput(params))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.updateCustomerAddress) !== null && _a !== void 0 ? _a : { id: null }];
            }
        });
    }); },
};
var index$h = useAddressesFactory(factoryParams$v);

var useCartFactory = function (factoryParams) { return function useCart() {
    var _this = this;
    var loading = sharedRef(false, 'useCart-loading');
    var cart = sharedRef(null, 'useCart-cart');
    var error = sharedRef({
        addItem: null,
        bulkAddItems: null,
        removeItem: null,
        bulkRemoveItems: null,
        updateItemQty: null,
        bulkUpdateItemsQty: null,
        load: null,
        clear: null,
        applyCoupon: null,
        removeCoupon: null,
        applyGiftCard: null,
        removeGiftCard: null,
        addNoteOnCart: null,
    }, 'useCart-error');
    // eslint-disable-next-line no-underscore-dangle,@typescript-eslint/naming-convention
    var _factoryParams = configureFactoryParams(factoryParams, {
        mainRef: cart,
        alias: 'currentCart',
        loading: loading,
        error: error,
    });
    var setCart = function (newCart) {
        cart.value = newCart;
        Logger.debug('useCartFactory.setCart', newCart);
    };
    var restrictProduct = function (_a) {
        var product = _a.product, getExpectedQuantity = _a.getExpectedQuantity, updatedCart = _a.updatedCart, action = _a.action;
        var sku = (product === null || product === void 0 ? void 0 : product.sku) || '';
        var getItemQty = function (cartValue) {
            var _a, _b, _c;
            return (_c = (_b = (_a = cartValue === null || cartValue === void 0 ? void 0 : cartValue.items) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.product.sku === sku; })) === null || _b === void 0 ? void 0 : _b.quantity) !== null && _c !== void 0 ? _c : 0;
        };
        var expectedQty = getExpectedQuantity(getItemQty(cart.value));
        var actualQty = getItemQty(updatedCart);
        if (actualQty && expectedQty > actualQty) {
            var err = new Error('You reached the maximum saleable quantity');
            Logger.debug('[Restricted]:', "Max saleable quantity is ".concat(actualQty));
            error.value[action] = err;
        }
        else {
            error.value[action] = null;
        }
        cart.value = updatedCart;
    };
    var addItem = function (_a) {
        var product = _a.product, quantity = _a.quantity, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_1;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        Logger.debug('useCart.addItem', {
                            product: product,
                            quantity: quantity,
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.addItem({
                                currentCart: cart.value,
                                product: product,
                                quantity: quantity,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = _d.sent();
                        error.value.addItem = null;
                        restrictProduct({
                            product: (_c = (_b = product === null || product === void 0 ? void 0 : product.configurable_product_options_selection) === null || _b === void 0 ? void 0 : _b.variant) !== null && _c !== void 0 ? _c : product,
                            getExpectedQuantity: function (currentQuantity) {
                                return currentQuantity + quantity;
                            },
                            updatedCart: updatedCart,
                            action: 'addItem',
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _d.sent();
                        error.value.addItem = err_1;
                        Logger.error('useCart/addItem', err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var bulkAddItems = function (_a) {
        var products = _a.products, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart_1, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.bulkAddItems', { products: products });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.bulkAddItems({
                                currentCart: cart.value,
                                products: products,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart_1 = _b.sent();
                        error.value.bulkAddItems = null;
                        products.forEach(function (item) {
                            var _a, _b;
                            restrictProduct({
                                product: (_b = (_a = item === null || item === void 0 ? void 0 : item.configurable_product_options_selection) === null || _a === void 0 ? void 0 : _a.variant) !== null && _b !== void 0 ? _b : item,
                                getExpectedQuantity: function (currentQuantity) {
                                    return currentQuantity + ((item === null || item === void 0 ? void 0 : item.quantity) || 1);
                                },
                                updatedCart: updatedCart_1,
                                action: 'bulkAddItems',
                            });
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _b.sent();
                        error.value.bulkAddItems = err_2;
                        Logger.error('useCart/bulkAddItems', err_2);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var removeItem = function (_a) {
        var product = _a.product, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.removeItem', { product: product });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.removeItem({
                                currentCart: cart.value,
                                product: product,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = _b.sent();
                        error.value.removeItem = null;
                        cart.value = updatedCart;
                        return [3 /*break*/, 5];
                    case 3:
                        err_3 = _b.sent();
                        error.value.removeItem = err_3;
                        Logger.error('useCart/removeItem', err_3);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var bulkRemoveItems = function (_a) {
        var products = _a.products, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.bulkRemoveItems', { products: products });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.bulkRemoveItems({
                                currentCart: cart.value,
                                products: products,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = _b.sent();
                        error.value.bulkRemoveItems = null;
                        cart.value = updatedCart;
                        return [3 /*break*/, 5];
                    case 3:
                        err_4 = _b.sent();
                        error.value.bulkRemoveItems = err_4;
                        Logger.error('useCart/bulkRemoveItems', err_4);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var updateItemQty = function (_a) {
        var product = _a.product, quantity = _a.quantity, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.updateItemQty', {
                            product: product,
                            quantity: quantity,
                        });
                        if (!(quantity && quantity > 0)) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.updateItemQty({
                                currentCart: cart.value,
                                product: product,
                                quantity: quantity,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = _b.sent();
                        error.value.updateItemQty = null;
                        restrictProduct({
                            product: product.product,
                            getExpectedQuantity: function () {
                                return quantity;
                            },
                            updatedCart: updatedCart,
                            action: 'updateItemQty',
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_5 = _b.sent();
                        error.value.updateItemQty = err_5;
                        Logger.error('useCart/updateItemQty', err_5);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var bulkUpdateItemsQty = function (_a) {
        var products = _a.products, quantityMap = _a.quantityMap, subtract = _a.subtract, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart_2, err_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.bulkUpdateItemsQty', {
                            products: products,
                            quantityMap: quantityMap,
                            subtract: subtract,
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.bulkUpdateItemsQty({
                                currentCart: cart.value,
                                products: products,
                                quantityMap: quantityMap,
                                subtract: subtract,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart_2 = _b.sent();
                        error.value.bulkUpdateItemsQty = null;
                        products.forEach(function (product) {
                            restrictProduct({
                                product: product.product,
                                getExpectedQuantity: function () {
                                    return quantityMap &&
                                        Object.keys(quantityMap).length > 0 &&
                                        Object.keys(quantityMap).includes(product.uid) ?
                                        quantityMap[product.uid] :
                                        !!subtract ? product.quantity - 1 :
                                            product.quantity + 1;
                                },
                                updatedCart: updatedCart_2,
                                action: 'updateItemQty',
                            });
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_6 = _b.sent();
                        error.value.bulkUpdateItemsQty = err_6;
                        Logger.error('useCart/bulkUpdateItemsQty', err_6);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var load = function (_a) {
        var _b = _a === void 0 ? { customQuery: undefined } : _a, customQuery = _b.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var _c, err_7;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        Logger.debug('useCart.load', cart.value);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        _c = cart;
                        return [4 /*yield*/, _factoryParams.load({ customQuery: customQuery })];
                    case 2:
                        _c.value = _d.sent();
                        error.value.load = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_7 = _d.sent();
                        error.value.load = err_7;
                        Logger.error('useCart/load', err_7);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var clear = function () { return __awaiter(_this, void 0, void 0, function () {
        var updatedCart, err_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('useCart.clear');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.clear({ currentCart: cart.value })];
                case 2:
                    updatedCart = _a.sent();
                    error.value.clear = null;
                    cart.value = updatedCart;
                    return [3 /*break*/, 5];
                case 3:
                    err_8 = _a.sent();
                    error.value.clear = err_8;
                    Logger.error('useCart/clear', err_8);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var isInCart = function (_a) {
        var product = _a.product;
        return _factoryParams.isInCart({
            currentCart: cart.value,
            product: product,
        });
    };
    var applyCoupon = function (_a) {
        var couponCode = _a.couponCode, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_9;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.applyCoupon');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.applyCoupon({
                                currentCart: cart.value,
                                couponCode: couponCode,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = (_b.sent()).updatedCart;
                        error.value.applyCoupon = null;
                        if (updatedCart) {
                            cart.value = updatedCart;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_9 = _b.sent();
                        error.value.applyCoupon = err_9;
                        Logger.error('useCart/applyCoupon', err_9);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var removeCoupon = function (_a) {
        var couponCode = _a.couponCode, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_10;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.removeCoupon');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.removeCoupon({
                                currentCart: cart.value,
                                couponCode: couponCode,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = (_b.sent()).updatedCart;
                        error.value.removeCoupon = null;
                        if (updatedCart) {
                            cart.value = updatedCart;
                        }
                        loading.value = false;
                        return [3 /*break*/, 5];
                    case 3:
                        err_10 = _b.sent();
                        error.value.removeCoupon = err_10;
                        Logger.error('useCart/removeCoupon', err_10);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var applyGiftCard = function (_a) {
        var giftCardCode = _a.giftCardCode, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_11;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.applyGiftCard');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.applyGiftCard({
                                currentCart: cart.value,
                                giftCardCode: giftCardCode,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = (_b.sent()).updatedCart;
                        error.value.applyGiftCard = null;
                        if (updatedCart) {
                            cart.value = updatedCart;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_11 = _b.sent();
                        error.value.applyGiftCard = err_11;
                        Logger.error('useCart/applyGiftCard', err_11);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var removeGiftCard = function (_a) {
        var giftCardCode = _a.giftCardCode, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_12;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.removeGiftCard');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.removeGiftCard({
                                currentCart: cart.value,
                                giftCardCode: giftCardCode,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = (_b.sent()).updatedCart;
                        error.value.removeGiftCard = null;
                        if (updatedCart) {
                            cart.value = updatedCart;
                        }
                        loading.value = false;
                        return [3 /*break*/, 5];
                    case 3:
                        err_12 = _b.sent();
                        error.value.removeGiftCard = err_12;
                        Logger.error('useCart/removeGiftCard', err_12);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var addNoteOnCart = function (_a) {
        var note = _a.note, customQuery = _a.customQuery;
        return __awaiter(_this, void 0, void 0, function () {
            var updatedCart, err_13;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useCart.addNoteOnCart');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.addNoteOnCart({
                                currentCart: cart.value,
                                note: note,
                                customQuery: customQuery,
                            })];
                    case 2:
                        updatedCart = (_b.sent()).updatedCart;
                        error.value.addNoteOnCart = null;
                        if (updatedCart) {
                            cart.value = updatedCart;
                        }
                        loading.value = false;
                        return [3 /*break*/, 5];
                    case 3:
                        err_13 = _b.sent();
                        error.value.addNoteOnCart = err_13;
                        Logger.error('useCart/addNoteOnCart', err_13);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return {
        api: _factoryParams.api,
        setCart: setCart,
        cart: computed(function () { return cart.value; }),
        isInCart: isInCart,
        addItem: addItem,
        bulkAddItems: bulkAddItems,
        load: load,
        removeItem: removeItem,
        bulkRemoveItems: bulkRemoveItems,
        clear: clear,
        updateItemQty: updateItemQty,
        bulkUpdateItemsQty: bulkUpdateItemsQty,
        applyCoupon: applyCoupon,
        removeCoupon: removeCoupon,
        applyGiftCard: applyGiftCard,
        removeGiftCard: removeGiftCard,
        addNoteOnCart: addNoteOnCart,
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
    };
}; };

var factoryParams$u = {
    load: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var apiState, customerToken, virtual, customQuery, createVirtualCart, createRealCart, getCartData, getCart, _a, data, errors, cartId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    apiState = context.$gemini.config.state;
                    Logger.debug('[Gemini Storefront]: Loading Cart');
                    customerToken = apiState.getCustomerToken();
                    virtual = !params.realCart;
                    customQuery = params.customQuery;
                    createVirtualCart = function () { return null; };
                    createRealCart = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    Logger.debug('[Gemini Storefront]: useCart.load.createNewCart');
                                    apiState.setCartId();
                                    return [4 /*yield*/, context.$gemini.api.createEmptyCart(customQuery)];
                                case 1:
                                    data = (_a.sent()).data;
                                    Logger.debug('[Result]:', { data: data });
                                    apiState.setCartId(data.createEmptyCart);
                                    return [2 /*return*/, data.createEmptyCart];
                            }
                        });
                    }); };
                    getCartData = function (id) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, data, errors;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    Logger.debug('[Gemini Storefront]: useCart.load.getCartData ID->', id);
                                    return [4 /*yield*/, context.$gemini.api.cart(id, customQuery)];
                                case 1:
                                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                                    Logger.debug('[Result]:', { data: data });
                                    if (!(data === null || data === void 0 ? void 0 : data.cart) && (errors === null || errors === void 0 ? void 0 : errors.length)) {
                                        throw errors[0];
                                    }
                                    return [2 /*return*/, data.cart];
                            }
                        });
                    }); };
                    getCart = function (virtualCart, cartId) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!!cartId) return [3 /*break*/, 2];
                                    if (virtualCart) {
                                        return [2 /*return*/, createVirtualCart()];
                                    }
                                    return [4 /*yield*/, createRealCart()];
                                case 1:
                                    cartId = _a.sent();
                                    apiState.setCartId(cartId);
                                    _a.label = 2;
                                case 2: return [2 /*return*/, getCartData(cartId)];
                            }
                        });
                    }); };
                    if (!customerToken) return [3 /*break*/, 4];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, context.$gemini.api.customerCart(customQuery)];
                case 2:
                    _a = _d.sent(), data = _a.data, errors = _a.errors;
                    Logger.debug('[Result]:', { data: data, errors: errors });
                    if (!(data === null || data === void 0 ? void 0 : data.customerCart) && (errors === null || errors === void 0 ? void 0 : errors.length)) {
                        throw errors[0];
                    }
                    apiState.setCartId(data.customerCart.id);
                    return [2 /*return*/, data.customerCart];
                case 3:
                    _d.sent();
                    apiState.setCustomerToken();
                    return [3 /*break*/, 4];
                case 4:
                    _d.trys.push([4, 6, , 8]);
                    cartId = apiState.getCartId();
                    return [4 /*yield*/, getCart(virtual, cartId)];
                case 5: return [2 /*return*/, _d.sent()];
                case 6:
                    _d.sent();
                    apiState.setCartId();
                    return [4 /*yield*/, getCart(virtual)];
                case 7: return [2 /*return*/, _d.sent()];
                case 8: return [2 /*return*/];
            }
        });
    }); },
    addItem: function (context, _a) {
        var product = _a.product, quantity = _a.quantity, currentCart = _a.currentCart, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var apiState, currentCartId, _b, simpleCartInput, simpleProduct, cartItems, configurableCartInput, configurableProduct;
            var _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        Logger.debug('[Gemini]: Add item to cart', {
                            product: product,
                            quantity: quantity,
                            currentCart: currentCart,
                        });
                        apiState = context.$gemini.config.state;
                        currentCartId = apiState.getCartId();
                        if (!!currentCartId) return [3 /*break*/, 2];
                        return [4 /*yield*/, factoryParams$u.load(context, {
                                realCart: true,
                            })];
                    case 1:
                        _g.sent();
                        currentCartId = apiState.getCartId();
                        _g.label = 2;
                    case 2:
                        if (!product) {
                            return [2 /*return*/];
                        }
                        _b = product.vsf_typename;
                        switch (_b) {
                            case 'SimpleProduct': return [3 /*break*/, 3];
                            case 'ConfigurableProduct': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        simpleCartInput = {
                            cartId: currentCartId,
                            cartItems: [
                                {
                                    quantity: quantity,
                                    sku: product.sku,
                                },
                            ],
                        };
                        return [4 /*yield*/, context.$gemini.api.addProductsToCart(simpleCartInput, customQuery)];
                    case 4:
                        simpleProduct = _g.sent();
                        Logger.debug('[Result]:', { data: simpleProduct });
                        if (((_c = simpleProduct === null || simpleProduct === void 0 ? void 0 : simpleProduct.errors) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                            throw simpleProduct.errors[0];
                        }
                        // eslint-disable-next-line consistent-return
                        return [2 /*return*/, simpleProduct.data.addProductsToCart.cart];
                    case 5:
                        cartItems = [
                            {
                                parent_sku: product.sku,
                                data: {
                                    quantity: quantity,
                                    sku: ((_e = (_d = product.configurable_product_options_selection) === null || _d === void 0 ? void 0 : _d.variant) === null || _e === void 0 ? void 0 : _e.sku) || '',
                                },
                            },
                        ];
                        configurableCartInput = {
                            cart_id: currentCartId,
                            cart_items: cartItems,
                        };
                        return [4 /*yield*/, context.$gemini.api.addConfigurableProductsToCart(configurableCartInput, customQuery)];
                    case 6:
                        configurableProduct = _g.sent();
                        Logger.debug('[Result]:', { data: configurableProduct });
                        if (((_f = configurableProduct === null || configurableProduct === void 0 ? void 0 : configurableProduct.errors) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                            throw configurableProduct.errors[0];
                        }
                        // eslint-disable-next-line consistent-return
                        return [2 /*return*/, configurableProduct.data.addConfigurableProductsToCart.cart];
                    case 7: 
                    // todo implement other options
                    // @ts-ignore
                    // eslint-disable-next-line no-underscore-dangle
                    throw new Error("Product Type ".concat(product.__typename, " not supported in add to cart yet"));
                }
            });
        });
    },
    /* Accept an array of simple products and add to cart all at once */
    bulkAddItems: function (context, _a) {
        var products = _a.products, currentCart = _a.currentCart, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var apiState, currentCartId, bulkSimpleCartInput, bulkSimpleProducts;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Add items to cart', {
                            products: products,
                            currentCart: currentCart,
                        });
                        apiState = context.$gemini.config.state;
                        currentCartId = apiState.getCartId();
                        if (!!currentCartId) return [3 /*break*/, 2];
                        return [4 /*yield*/, factoryParams$u.load(context, {
                                realCart: true,
                            })];
                    case 1:
                        _c.sent();
                        currentCartId = apiState.getCartId();
                        _c.label = 2;
                    case 2:
                        if (!products || (products === null || products === void 0 ? void 0 : products.length) < 1) {
                            return [2 /*return*/];
                        }
                        bulkSimpleCartInput = {
                            cartId: currentCartId,
                            cartItems: products.map(function (item) {
                                return {
                                    quantity: (item === null || item === void 0 ? void 0 : item.quantity) || 1,
                                    sku: item.product.sku,
                                };
                            })
                        };
                        return [4 /*yield*/, context.$gemini.api.addProductsToCart(bulkSimpleCartInput, customQuery)];
                    case 3:
                        bulkSimpleProducts = _c.sent();
                        Logger.debug('[Result]:', { data: bulkSimpleCartInput });
                        if (((_b = bulkSimpleProducts === null || bulkSimpleProducts === void 0 ? void 0 : bulkSimpleProducts.errors) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            throw bulkSimpleProducts.errors[0];
                        }
                        return [2 /*return*/, bulkSimpleProducts.data.addProductsToCart.cart];
                }
            });
        });
    },
    removeItem: function (context, _a) {
        var currentCart = _a.currentCart, product = _a.product, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var item, removeItemParams, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini]: Remove item from cart', {
                            product: product,
                            currentCart: currentCart,
                        });
                        item = currentCart.items.find(function (cartItem) { return cartItem.uid === product.uid; });
                        if (!item) {
                            return [2 /*return*/];
                        }
                        removeItemParams = {
                            cart_id: currentCart.id,
                            cart_item_uid: item.uid,
                        };
                        return [4 /*yield*/, context.$gemini.api.removeItemFromCart(removeItemParams, customQuery)];
                    case 1:
                        data = (_b.sent()).data;
                        Logger.debug('[Result]:', { data: data });
                        // eslint-disable-next-line consistent-return
                        return [2 /*return*/, data.removeItemFromCart.cart];
                }
            });
        });
    },
    bulkRemoveItems: function (context, _a) {
        var currentCart = _a.currentCart, products = _a.products, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var cleanedItems, removeResults;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini]: Remove items from cart', {
                            products: products,
                            currentCart: currentCart,
                        });
                        cleanedItems = [];
                        products.forEach(function (productToRemove) {
                            var match = currentCart.items.find(function (cartItem) { return cartItem.uid === productToRemove.uid; });
                            if (!!match) {
                                cleanedItems.push(match);
                            }
                        });
                        if (!cleanedItems && (cleanedItems === null || cleanedItems === void 0 ? void 0 : cleanedItems.length) < 1) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Promise.all(cleanedItems.map(function (itemToRemove) {
                                return context.$gemini.api.removeItemFromCart({
                                    cart_id: currentCart.id,
                                    cart_item_uid: itemToRemove.uid,
                                }, customQuery);
                            }))];
                    case 1:
                        removeResults = _b.sent();
                        removeResults.forEach(function (result) {
                            var _a;
                            if (((_a = result === null || result === void 0 ? void 0 : result.errors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                throw result.errors[0];
                            }
                            else {
                                Logger.debug('[Result]:', result.data);
                            }
                        });
                        return [2 /*return*/, removeResults[!!(removeResults === null || removeResults === void 0 ? void 0 : removeResults.length) ? removeResults.length - 1 : 0].data.removeItemFromCart.cart];
                }
            });
        });
    },
    updateItemQty: function (context, _a) {
        var currentCart = _a.currentCart, product = _a.product, quantity = _a.quantity, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var updateCartParams, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Update product quantity on cart', {
                            product: product,
                            quantity: quantity,
                            currentCart: currentCart,
                        });
                        updateCartParams = {
                            cart_id: currentCart.id,
                            cart_items: [
                                {
                                    cart_item_uid: product.uid,
                                    quantity: quantity,
                                },
                            ],
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, context.$gemini.api.updateCartItems(updateCartParams, customQuery)];
                    case 2:
                        data = (_c.sent()).data;
                        Logger.debug('[Result]:', { data: data });
                        return [2 /*return*/, data.updateCartItems.cart];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, factoryParams$u.load(context, {
                                realCart: true,
                            })];
                    case 4: 
                    // If we can't change quantity, the card could be expired on Gemini side, try to reload
                    return [2 /*return*/, _c.sent()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    /* If a map with cartItem.uid => newQuantity is provided in quantityMap, the mutation will act accordingly. If subtract bool is true, the current
      quantity of all items will be decreased by 1. If none of the optional parameters is defined, the quantity of all items will be increased by 1 */
    bulkUpdateItemsQty: function (context, _a) {
        var currentCart = _a.currentCart, products = _a.products, quantityMap = _a.quantityMap, subtract = _a.subtract, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var bulkUpdateCartParams, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Update product quantity on cart', {
                            products: products,
                            quantityMap: quantityMap,
                            subtract: subtract,
                            currentCart: currentCart,
                        });
                        bulkUpdateCartParams = {
                            cart_id: currentCart.id,
                            cart_items: products.map(function (product) {
                                var _a, _b;
                                var newQuantity;
                                if (quantityMap &&
                                    ((_a = Object.keys(quantityMap)) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                                    ((_b = Object.keys(quantityMap)) === null || _b === void 0 ? void 0 : _b.includes(product === null || product === void 0 ? void 0 : product.uid))) {
                                    newQuantity = quantityMap[product.uid];
                                }
                                else if (!!subtract) {
                                    newQuantity = product.quantity - 1;
                                }
                                else {
                                    newQuantity = product.quantity + 1;
                                }
                                return {
                                    cart_item_uid: product.uid,
                                    quantity: newQuantity,
                                };
                            })
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, context.$gemini.api.updateCartItems(bulkUpdateCartParams, customQuery)];
                    case 2:
                        data = (_c.sent()).data;
                        Logger.debug('[Result]:', { data: data });
                        return [2 /*return*/, data.updateCartItems.cart];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, factoryParams$u.load(context, {
                                realCart: true,
                            })];
                    case 4: 
                    // If we can't change quantity, the card could be expired on Gemini side, try to reload
                    return [2 /*return*/, _c.sent()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clear: function (context, _params) {
        context.$gemini.config.state.setCartId(null);
        return factoryParams$u.load(context, {});
    },
    applyCoupon: function (context, _a) {
        var currentCart = _a.currentCart, couponCode = _a.couponCode, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, data, errors, cart;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Apply coupon on cart', {
                            couponCode: couponCode,
                            currentCart: currentCart,
                        });
                        return [4 /*yield*/, context.$gemini.api.applyCouponToCart({
                                cart_id: currentCart.id,
                                coupon_code: couponCode,
                            }, customQuery)];
                    case 1:
                        _b = _c.sent(), data = _b.data, errors = _b.errors;
                        if (errors === null || errors === void 0 ? void 0 : errors.length) {
                            throw errors[0];
                        }
                        Logger.debug('[Result]:', { data: data });
                        if (data.applyCouponToCart) {
                            cart = data.applyCouponToCart.cart;
                        }
                        return [2 /*return*/, {
                                updatedCart: cart,
                                updatedCoupon: { code: couponCode },
                                errors: errors,
                            }];
                }
            });
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeCoupon: function (context, _a) {
        var currentCart = _a.currentCart, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, data, errors;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Remove coupon from cart', { currentCart: currentCart });
                        return [4 /*yield*/, context.$gemini.api.removeCouponFromCart({
                                cart_id: currentCart.id,
                            }, customQuery)];
                    case 1:
                        _b = _c.sent(), data = _b.data, errors = _b.errors;
                        if (errors === null || errors === void 0 ? void 0 : errors.length) {
                            throw errors[0];
                        }
                        Logger.debug('[Result]:', { data: data });
                        return [2 /*return*/, {
                                updatedCart: data.removeCouponFromCart.cart,
                                updatedCoupon: { code: '' },
                            }];
                }
            });
        });
    },
    applyGiftCard: function (context, _a) {
        var currentCart = _a.currentCart, giftCardCode = _a.giftCardCode, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini]: Apply coupon on cart', {
                            giftCardCode: giftCardCode,
                            currentCart: currentCart,
                        });
                        return [4 /*yield*/, context.$gemini.api.applyGiftCardToCart({
                                cart_id: currentCart.id,
                                giftcard_code: giftCardCode,
                            }, customQuery)];
                    case 1:
                        data = (_b.sent()).data;
                        Logger.debug('[Result]:', { data: data });
                        return [2 /*return*/, {
                                updatedCart: data.applyGiftCardToCart.cart,
                                updatedGiftCard: { code: giftCardCode },
                            }];
                }
            });
        });
    },
    removeGiftCard: function (context, _a) {
        var currentCart = _a.currentCart, giftCardCode = _a.giftCardCode, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, data, errors;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Remove gift card from cart', { currentCart: currentCart });
                        return [4 /*yield*/, context.$gemini.api.removeGiftCardFromCart({
                                cart_id: currentCart.id,
                                giftcard_code: giftCardCode,
                            }, customQuery)];
                    case 1:
                        _b = _c.sent(), data = _b.data, errors = _b.errors;
                        if (errors === null || errors === void 0 ? void 0 : errors.length) {
                            throw errors[0];
                        }
                        Logger.debug('[Result]:', { data: data, errors: errors });
                        return [2 /*return*/, {
                                updatedCart: data.removeGiftCardFromCart.cart,
                                updatedCoupon: { code: '' },
                            }];
                }
            });
        });
    },
    addNoteOnCart: function (context, _a) {
        var currentCart = _a.currentCart, note = _a.note, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, data, errors;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Logger.debug('[Gemini]: Add note to cart', { currentCart: currentCart, note: note });
                        return [4 /*yield*/, context.$gemini.api.setNotesToCart({
                                cart_id: currentCart.id,
                                notes: note,
                            }, customQuery)];
                    case 1:
                        _b = _c.sent(), data = _b.data, errors = _b.errors;
                        if (errors === null || errors === void 0 ? void 0 : errors.length) {
                            throw errors[0];
                        }
                        Logger.debug('[Result]:', { data: data, errors: errors });
                        return [2 /*return*/, {
                                updatedCart: data.cart,
                                updatedCoupon: { code: '' },
                            }];
                }
            });
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isInCart: function (context, _a) {
        var currentCart = _a.currentCart, product = _a.product;
        return !!(currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.find(function (cartItem) { var _a; return ((_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.product) === null || _a === void 0 ? void 0 : _a.uid) === product.uid; }));
    },
};
var useCart = useCartFactory(factoryParams$u);

var factoryParams$t = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    load: function (context, _a) {
        var customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        Logger.debug('[Gemini] loadShippingProvider', { customQuery: customQuery });
                        if (!!((_d = (_c = (_b = context.cart.cart) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.shipping_addresses[0]) === null || _d === void 0 ? void 0 : _d.selected_shipping_method)) return [3 /*break*/, 2];
                        return [4 /*yield*/, context.cart.load({ customQuery: customQuery })];
                    case 1:
                        _g.sent();
                        _g.label = 2;
                    case 2: return [2 /*return*/, (_f = (_e = context
                            .cart
                            .cart
                            .value) === null || _e === void 0 ? void 0 : _e.shipping_addresses[0]) === null || _f === void 0 ? void 0 : _f.selected_shipping_method];
                }
            });
        });
    },
    save: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var shippingMethodParams, data, cart;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini] saveShippingProvider', { params: params });
                    shippingMethodParams = {
                        cart_id: context.cart.cart.value.id,
                        shipping_methods: [__assign({}, params.shippingMethod)],
                    };
                    return [4 /*yield*/, context.$gemini.api.setShippingMethodsOnCart(shippingMethodParams, params.customQuery)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    cart = data
                        .setShippingMethodsOnCart.cart;
                    context.cart.setCart(cart);
                    return [2 /*return*/, cart
                            .shipping_addresses[0]
                            .selected_shipping_method];
            }
        });
    }); },
};
var useShippingProvider = useShippingProviderFactory(factoryParams$t);

var factoryParams$s = {
    provide: function () {
        return {
            useShippingProvider: useShippingProvider(),
            cart: useCart(),
        };
    },
    load: function (context, _a) {
        var customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        Logger.debug('[Gemini] loadBilling');
                        if (!!((_c = (_b = context.cart.cart) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.billing_address)) return [3 /*break*/, 2];
                        return [4 /*yield*/, context.cart.load({ customQuery: customQuery })];
                    case 1:
                        _h.sent();
                        _h.label = 2;
                    case 2: return [2 /*return*/, (_g = (_f = (_e = (_d = context === null || context === void 0 ? void 0 : context.cart) === null || _d === void 0 ? void 0 : _d.cart) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.billing_address) !== null && _g !== void 0 ? _g : {}];
                }
            });
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    save: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var id, _a, apartment, neighborhood, extra, sameAsShipping, customerAddressId, address, billingData, setBillingAddressOnCartInput, data, shippingMethod;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] setBillingAddress');
                    id = context.cart.cart.value.id;
                    _a = params.billingDetails, apartment = _a.apartment, neighborhood = _a.neighborhood, extra = _a.extra, sameAsShipping = _a.sameAsShipping, customerAddressId = _a.customerAddressId, address = __rest(_a, ["apartment", "neighborhood", "extra", "sameAsShipping", "customerAddressId"]);
                    billingData = customerAddressId
                        ? ({
                            customer_address_id: customerAddressId,
                            address: __assign(__assign({}, address), { street: [address.street, apartment, neighborhood, extra] }),
                        })
                        : ({
                            address: __assign(__assign({}, address), { street: [address.street, apartment, neighborhood, extra] }),
                            same_as_shipping: sameAsShipping,
                        });
                    setBillingAddressOnCartInput = {
                        cart_id: id,
                        billing_address: billingData,
                    };
                    return [4 /*yield*/, context.$gemini.api.setBillingAddressOnCart(setBillingAddressOnCartInput)];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    shippingMethod = context.useShippingProvider.state.value;
                    Logger.debug('[Gemini]: Defining the shipping method as:', JSON.stringify(shippingMethod, null, 2));
                    return [4 /*yield*/, context.useShippingProvider.save({
                            shippingMethod: {
                                carrier_code: shippingMethod.carrier_code,
                                method_code: shippingMethod.method_code,
                            },
                        })];
                case 2:
                    _b.sent();
                    /**
                     * End of GraphQL Workaround
                     */
                    return [2 /*return*/, data.setBillingAddressOnCart.cart.billing_address];
            }
        });
    }); },
};
var index$g = useBillingFactory(factoryParams$s);

var factoryParams$r = {
    // @ts-ignore
    categorySearch: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var customQuery, queryParams, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: List available categories', { params: params });
                    customQuery = params.customQuery, queryParams = __rest(params, ["customQuery"]);
                    return [4 /*yield*/, context.$gemini.api.categoryList(queryParams, customQuery)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data.categories.items];
            }
        });
    }); },
};
var index$f = useCategoryFactory(factoryParams$r);

function useCategorySearchFactory(factoryParams) {
    return function useCategorySearch(id) {
        var _this = this;
        if (id === void 0) { id = ''; }
        var ssrKey = id || 'useCategorySearch';
        // @ts-ignore
        var result = sharedRef([], "".concat(ssrKey, "-result"));
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        var error = sharedRef({
            search: null,
        }, "".concat(ssrKey, "-error"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        // eslint-disable-next-line consistent-return
        var search = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.debug("useCategorySearch/".concat(ssrKey, "/search"));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.search(params)];
                    case 2:
                        data = _a.sent();
                        result.value = data;
                        error.value.search = null;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _a.sent();
                        error.value.search = err_1;
                        Logger.error("useCategorySearch/".concat(ssrKey, "/search"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            search: search,
            result: computed(function () { return result.value; }),
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$q = {
    search: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var filters, customQuery, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Search for category using', { params: params });
                    filters = params.filters, customQuery = params.customQuery;
                    return [4 /*yield*/, context.$gemini.api.categorySearch({ filters: filters }, customQuery)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data.categoryList];
            }
        });
    }); },
};
var useCategorySearch = useCategorySearchFactory(factoryParams$q);
var useCategorySearch$1 = useCategorySearch;

function useConfigFactory(factoryParams) {
    return function useConfig(cacheId) {
        var _this = this;
        if (cacheId === void 0) { cacheId = ''; }
        var ssrKey = cacheId || 'useConfigFactory';
        // @ts-ignore
        var config = sharedRef({}, "".concat(ssrKey, "-config"));
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        var loadConfig = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useConfig/".concat(ssrKey, "/loadConfig"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = config;
                        return [4 /*yield*/, _factoryParams.loadConfig(params)];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return {
            loadConfig: loadConfig,
            config: computed(function () { return config.value; }),
            loading: computed(function () { return loading.value; }),
        };
    };
}

var factoryParams$p = {
    loadConfig: function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, context.$gemini.api.storeConfig()];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.storeConfig || {}];
            }
        });
    }); },
};
var useConfig = useConfigFactory(factoryParams$p);
var useConfig$1 = useConfig;

function useContentFactory(factoryParams) {
    return function useContent(ssrKey) {
        var _this = this;
        if (ssrKey === void 0) { ssrKey = 'useConfigFactory'; }
        // @ts-ignore
        var page = sharedRef({}, "useContent-content-".concat(ssrKey));
        var errors = sharedRef({
            content: null,
            blocks: null,
        }, 'useContent-error');
        var blocks = sharedRef([], "useContent-blocks-".concat(ssrKey));
        var loading = sharedRef(false, "useContent-loading-".concat(ssrKey));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        var loadContent = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useContent/".concat(ssrKey, "/loadPage"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        errors.value.content = null;
                        _a = page;
                        return [4 /*yield*/, _factoryParams.loadContent(params)];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        errors.value.content = error_1;
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // loadBlocks must be use only once, here in the AppFooter.vue. To use it add the identifiers in the identifiers list
        var loadBlocks = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useContent/".concat(ssrKey, "/loadBlocks"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        errors.value.blocks = null;
                        _a = blocks;
                        return [4 /*yield*/, _factoryParams.loadBlocks(params)];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _b.sent();
                        errors.value.blocks = error_2;
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            loadContent: loadContent,
            loadBlocks: loadBlocks,
            loading: computed(function () { return loading.value; }),
            page: computed(function () { return page.value; }),
            blocks: computed(function () { return blocks.value; }),
            error: computed(function () { return errors.value; }),
        };
    };
}

var factoryParams$o = {
    loadContent: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Load CMS Page content', { params: params });
                    return [4 /*yield*/, context.$gemini.api.cmsPage(params.identifier)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data.cmsPage];
            }
        });
    }); },
    loadBlocks: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Load CMS Blocks content', { params: params });
                    return [4 /*yield*/, context.$gemini.api.cmsBlocks(params.identifiers)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data.cmsBlocks.items];
            }
        });
    }); },
};
var index$e = useContentFactory(factoryParams$o);

function useCountrySearchFactory(factoryParams) {
    return function useCountrySearch(cacheId) {
        var _this = this;
        if (cacheId === void 0) { cacheId = ''; }
        var ssrKey = cacheId || 'useCountrySearchFactory';
        var countries = sharedRef([], "".concat(ssrKey, "-countries"));
        // @ts-ignore
        var country = sharedRef({}, "".concat(ssrKey, "-country"));
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        var error = sharedRef({
            load: null,
            search: null,
        }, "".concat(ssrKey, "-error"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        // eslint-disable-next-line consistent-return
        var load = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.debug("useCountrySearch/".concat(ssrKey, "/load"));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.load(params)];
                    case 2:
                        data = _a.sent();
                        countries.value = data;
                        error.value.load = null;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _a.sent();
                        error.value.load = err_1;
                        Logger.error("useCountrySearch/".concat(ssrKey, "/load"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // eslint-disable-next-line consistent-return
        var search = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var data, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.debug("useCountrySearch/".concat(ssrKey, "/search"));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.search(params)];
                    case 2:
                        data = _a.sent();
                        country.value = data;
                        error.value.search = null;
                        return [2 /*return*/, data];
                    case 3:
                        err_2 = _a.sent();
                        error.value.search = err_2;
                        Logger.error("useCountrySearch/".concat(ssrKey, "/search"), err_2);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            load: load,
            search: search,
            countries: computed(function () { return countries.value; }),
            country: computed(function () { return country.value; }),
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$n = {
    load: function (context, _params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Load available countries on store');
                    return [4 /*yield*/, context.$gemini.api.countries()];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data.countries];
            }
        });
    }); },
    search: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Search country information based on', { params: params });
                    return [4 /*yield*/, context.$gemini.api.country(params.id)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data.country];
            }
        });
    }); },
};
var useCountrySearch = useCountrySearchFactory(factoryParams$n);
var useCountrySearch$1 = useCountrySearch;

function useCurrencyFactory(factoryParams) {
    return function useCurrency(cacheId) {
        var _this = this;
        if (cacheId === void 0) { cacheId = ''; }
        var ssrKey = cacheId || 'useCurrencyFactory';
        // @ts-ignore
        var currencies = sharedRef([], "".concat(ssrKey, "-currencies"));
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        var load = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useCurrency/".concat(ssrKey, "/load"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = currencies;
                        return [4 /*yield*/, _factoryParams.load(params)];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var change = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.debug("useCurrency/".concat(ssrKey, "/change"));
                        loading.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, _factoryParams.change(params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return {
            load: load,
            change: change,
            currencies: computed(function () { return currencies.value; }),
            loading: computed(function () { return loading.value; }),
        };
    };
}

var factoryParams$m = {
    load: function (context, _params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, context.$gemini.api.currency()];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.currency || {}];
            }
        });
    }); },
    change: function (context, params) {
        context.$gemini.config.state.setCurrency(params.id);
    },
};
var useCurrency = useCurrencyFactory(factoryParams$m);
var useCurrency$1 = useCurrency;

var useCustomMutationFactory = function (factoryParams) { return function useCustomMutation(ssrKey) {
    var _this = this;
    if (ssrKey === void 0) { ssrKey = 'useCustomMutation'; }
    // @ts-ignore
    var mutationString = sharedRef('', "".concat(ssrKey, "-mutationString"));
    var mutationStringComputed = computed(function () { return mutationString.value; });
    // @ts-ignore
    var result = sharedRef({}, "".concat(ssrKey, "-result"));
    var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
    var error = sharedRef({
        query: null,
    }, "".concat(ssrKey, "-error"));
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    // eslint-disable-next-line consistent-return
    var mutation = function (_a) {
        var variables = _a.variables, fetchPolicy = _a.fetchPolicy;
        return __awaiter(_this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useCustomMutation/".concat(ssrKey, "/mutation"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, _factoryParams.mutation({
                                mutation: mutationStringComputed.value,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                            })];
                    case 2:
                        data = _b.sent();
                        result.value = data;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _b.sent();
                        error.value.search = err_1;
                        Logger.error("useCustomMutation/".concat(ssrKey, "/mutation"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return {
        setMutationString: function (newMutationString) {
            mutationString.value = newMutationString;
        },
        mutationString: mutationStringComputed,
        mutation: mutation,
        result: computed(function () { return result.value; }),
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
    };
}; };

var index$d = useCustomMutationFactory({
    mutation: function (context, _a) {
        var mutation = _a.mutation, variables = _a.variables, fetchPolicy = _a.fetchPolicy;
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini] Custom API Mutation', { variables: variables });
                        return [4 /*yield*/, context.$gemini.api.customMutation({
                                mutation: mutation,
                                mutationVariables: variables,
                                fetchPolicy: fetchPolicy,
                            })];
                    case 1:
                        result = _b.sent();
                        Logger.debug('[Custom Mutation -> Result]:', result);
                        return [2 /*return*/, result];
                }
            });
        });
    },
});

var useCustomQueryFactory = function (factoryParams) { return function useCustomQuery(ssrKey) {
    var _this = this;
    if (ssrKey === void 0) { ssrKey = 'useCustomQuery'; }
    // @ts-ignore
    var queryString = sharedRef('', "".concat(ssrKey, "-queryString"));
    var queryStringComputed = computed(function () { return queryString.value; });
    // @ts-ignore
    var result = sharedRef({}, "".concat(ssrKey, "-result"));
    var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
    var error = sharedRef({
        query: null,
    }, "".concat(ssrKey, "-error"));
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    // eslint-disable-next-line consistent-return
    var query = function (_a) {
        var variables = _a.variables, fetchPolicy = _a.fetchPolicy;
        return __awaiter(_this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useCustomQuery/".concat(ssrKey, "/query"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, _factoryParams.query({
                                query: queryStringComputed.value,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                            })];
                    case 2:
                        data = _b.sent();
                        result.value = data;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _b.sent();
                        error.value.search = err_1;
                        Logger.error("useCustomQuery/".concat(ssrKey, "/query"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return {
        setQueryString: function (newQueryString) {
            queryString.value = newQueryString;
        },
        queryString: queryStringComputed,
        query: query,
        result: computed(function () { return result.value; }),
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
    };
}; };

var index$c = useCustomQueryFactory({
    query: function (context, _a) {
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy;
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini] Custom API Query', { variables: variables });
                        return [4 /*yield*/, context.$gemini.api.customQuery({
                                query: query,
                                queryVariables: variables,
                                fetchPolicy: fetchPolicy,
                            })];
                    case 1:
                        result = _b.sent();
                        Logger.debug('[Custom Query -> Result]:', result);
                        return [2 /*return*/, result];
                }
            });
        });
    },
});

var useExternalCheckoutFactory = function (factoryParams) {
    function useExternalCheckout(ssrKey) {
        var _this = this;
        if (ssrKey === void 0) { ssrKey = 'useExternalCheckout'; }
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        var error = sharedRef({
            search: null,
        }, "".concat(ssrKey, "-error"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        // eslint-disable-next-line @typescript-eslint/require-await,consistent-return
        var initializeCheckout = function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Logger.debug("useExternalCheckout/".concat(ssrKey, "/initializeCheckout"));
                loading.value = true;
                try {
                    return [2 /*return*/, _factoryParams.initializeCheckout(params)];
                }
                catch (err) {
                    error.value.search = err;
                    Logger.error("useExternalCheckout/".concat(ssrKey, "/initializeCheckout"), err);
                }
                finally {
                    loading.value = false;
                }
                return [2 /*return*/];
            });
        }); };
        return {
            initializeCheckout: initializeCheckout,
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    }
    return useExternalCheckout;
};

// import useConfig from '../useConfig';
var factoryParams$l = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    // eslint-disable-next-line @typescript-eslint/require-await
    initializeCheckout: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, externalCheckout, state, userToken, cartToken;
        return __generator(this, function (_b) {
            Logger.debug('[Gemini]: Initialize external checkout', { params: params });
            _a = context.$gemini.config, externalCheckout = _a.externalCheckout, state = _a.state;
            userToken = state.getCustomerToken();
            cartToken = state.getCartId();
            Logger.debug({ userToken: userToken, cartToken: cartToken });
            if (externalCheckout.enable) {
                if (userToken && cartToken) {
                    // @TODO: Implements Multiple Store
                    /* if (Object.keys(externalCheckout.stores).length) {
            
                    } */
                    window.location.replace("".concat(externalCheckout.cmsUrl).concat(externalCheckout.syncUrlPath, "/token/").concat(userToken, "/cart/").concat(cartToken));
                    return [2 /*return*/, ''];
                }
                window.location.replace("".concat(externalCheckout.cmsUrl).concat(externalCheckout.syncUrlPath, "/token//cart/").concat(cartToken));
                return [2 /*return*/, ''];
            }
            return [2 /*return*/, params.baseUrl];
        });
    }); },
};
var index$b = useExternalCheckoutFactory(factoryParams$l);

var availableSortingOptions = [
    {
        label: 'Sort: Default',
        value: '',
    },
    {
        label: 'Sort: New arrivals',
        value: 'creation_DESC',
    },
    {
        label: 'Sort: Price from low to high',
        value: 'price_ASC',
    },
    {
        label: 'Sort: Price from high to low',
        value: 'price_DESC',
    },
];
var constructFilterObject = function (inputFilters) {
    var filter = {};
    Object.keys(inputFilters).forEach(function (key) {
        if (key === 'price') {
            var price = { from: 0, to: 0 };
            /* Legacy code. There's no reason to expect a multidimensional array, multiple values or values separated by an underscore.
            * Also, BE expects a string as value for from and to fields. Commenting it out and refactoring to use SfRange output => [min, max] */
            // eslint-disable-next-line
            /* const flatPrices = inputFilters[key].flatMap((inputFilter) => inputFilter.split('_').map((str) => Number.parseFloat(str))).sort((a, b) => a - b);
      
            [price.from] = flatPrices;
            price.to = flatPrices[flatPrices.length - 1];
             */
            /* Sorting array as a safety measure */
            var minMaxValues = inputFilters[key].sort(function (a, b) { return a - b; });
            /* Add fallback values to prevent filter form breaking search call */
            price.from = minMaxValues.length > 0 ? minMaxValues[0] : '0';
            price.to = minMaxValues.length > 1 ? minMaxValues[minMaxValues.length - 1] : '9999';
            filter[key] = price;
        }
        else if (typeof inputFilters[key] === 'string') {
            filter[key] = { in: [inputFilters[key]] };
        }
        else {
            filter[key] = { in: inputFilters[key] };
        }
    });
    return filter;
};
var constructSortObject = function (sortData) {
    var baseData = sortData.split(/_/gi);
    return baseData.length > 0 ? Object.fromEntries([baseData]) : {};
};
var factoryParams$k = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    search: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var isLastPage, itemsPerPage, inputFilters, categoryId, productParams, productSearchParams, data, totalCount, lastPage;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    Logger.debug('[Gemini] Load product facets', { params: params });
                    isLastPage = false;
                    itemsPerPage = (params.input.itemsPerPage) ? params.input.itemsPerPage : 20;
                    inputFilters = (params.input.filters) ? params.input.filters : {};
                    categoryId = (params.input.categoryId) ? {
                        category_uid: __assign({}, (Array.isArray(params.input.categoryId)
                            ? { in: params.input.categoryId }
                            : { eq: params.input.categoryId })),
                    } : {};
                    productParams = {
                        filter: __assign(__assign({}, categoryId), constructFilterObject(__assign({}, inputFilters))),
                        perPage: itemsPerPage,
                        offset: (params.input.page - 1) * itemsPerPage,
                        page: params.input.page,
                        search: (params.input.term) ? params.input.term : '',
                        sort: constructSortObject(params.input.sort || ''),
                    };
                    productSearchParams = {
                        pageSize: productParams.perPage,
                        search: productParams.search,
                        filter: productParams.filter,
                        sort: productParams.sort,
                        currentPage: productParams.page,
                    };
                    return [4 /*yield*/, context.$gemini.api.products(productSearchParams, (params === null || params === void 0 ? void 0 : params.input.customQuery) || { products: 'products' })];
                case 1:
                    data = (_e.sent()).data;
                    totalCount = (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.total_count;
                    if (totalCount) {
                        lastPage = Math.ceil(totalCount / productParams.perPage);
                        isLastPage = productSearchParams.currentPage >= lastPage;
                    }
                    else {
                        isLastPage = true;
                    }
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, {
                            items: ((_b = data === null || data === void 0 ? void 0 : data.products) === null || _b === void 0 ? void 0 : _b.items) || [],
                            total: (_c = data === null || data === void 0 ? void 0 : data.products) === null || _c === void 0 ? void 0 : _c.total_count,
                            availableFilters: (_d = data === null || data === void 0 ? void 0 : data.products) === null || _d === void 0 ? void 0 : _d.aggregations,
                            category: { id: params.input.categoryId },
                            availableSortingOptions: availableSortingOptions,
                            perPageOptions: [10, 20, 50],
                            itemsPerPage: itemsPerPage,
                            isLastPage: isLastPage,
                        }];
            }
        });
    }); },
};
var index$a = useFacetFactory(factoryParams$k);

function useForgotPasswordFactory(factoryParams) {
    return function useForgotPassword() {
        var _this = this;
        var result = sharedRef({
            resetPasswordResult: null,
            setNewPasswordResult: null,
        }, 'useForgotPassword-result');
        var loading = sharedRef(false, 'useProduct-loading');
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        var error = sharedRef({
            request: null,
            setNew: null,
        }, 'useForgotPassword-error');
        var request = function (resetPasswordParams) { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useForgotPassword/request', resetPasswordParams.email);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        // eslint-disable-next-line no-underscore-dangle
                        _a = result;
                        return [4 /*yield*/, _factoryParams.resetPassword(__assign({ currentResult: result.value }, resetPasswordParams))];
                    case 2:
                        // eslint-disable-next-line no-underscore-dangle
                        _a.value = _b.sent();
                        error.value.request = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        error.value.request = err_1;
                        Logger.error('useForgotPassword/request', err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var setNew = function (setNewPasswordParams) { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('useForgotPassword/setNew', setNewPasswordParams);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        // eslint-disable-next-line no-underscore-dangle
                        _a = result;
                        return [4 /*yield*/, _factoryParams.setNewPassword(__assign({ currentResult: result.value }, setNewPasswordParams))];
                    case 2:
                        // eslint-disable-next-line no-underscore-dangle
                        _a.value = _b.sent();
                        error.value.setNew = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _b.sent();
                        error.value.setNew = err_2;
                        Logger.error('useForgotPassword/setNew', err_2);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            request: request,
            setNew: setNew,
            result: computed(function () { return result.value; }),
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$j = {
    resetPassword: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Reset user password', { params: params });
                    return [4 /*yield*/, context.$gemini.api.requestPasswordResetEmail({ email: params.email })];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    if (!data.requestPasswordResetEmail)
                        throw new Error('Email was not found, or not available.');
                    return [2 /*return*/, data];
            }
        });
    }); },
    setNewPassword: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Define new user password', { params: params });
                    return [4 /*yield*/, context.$gemini.api.resetPassword({
                            newPassword: params.newPassword,
                            resetPasswordToken: params.tokenValue,
                        })];
                case 1:
                    data = (_a.sent()).data;
                    if (data === undefined) {
                        throw new Error('Email was not found, not available or token is expired. Please request a new password.');
                    }
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data];
            }
        });
    }); },
};
var useForgotPassword = useForgotPasswordFactory(factoryParams$j);
var useForgotPassword$1 = useForgotPassword;

function useGetShippingMethodsFactory(factoryParams) {
    return function useGetShippingMethods(id) {
        var _this = this;
        if (id === void 0) { id = ''; }
        // @ts-ignore
        var state = sharedRef(null, 'UseGetShippingMethods-response');
        var ssrKey = id || 'useGetShippingMethods';
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        var error = sharedRef({
            load: null,
        }, "".concat(ssrKey, "-error"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        // eslint-disable-next-line consistent-return
        var load = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.debug("useGetShippingMethods/".concat(ssrKey, "/load"), { params: params });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.load(params)];
                    case 2:
                        data = _a.sent();
                        state.value = data;
                        error.value.search = null;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _a.sent();
                        error.value.search = err_1;
                        Logger.error("useGetShippingMethods/".concat(ssrKey, "/load"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var setState = function (newState) {
            state.value = newState;
            Logger.debug('useGetShippingMethods.setState', newState);
        };
        return {
            state: state,
            setState: setState,
            load: load,
            result: computed(function () { return state.value; }),
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$i = {
    load: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var isGuest, data_1, hasAddresses_1, data, hasAddresses;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    Logger.debug('[Gemini]: Load shipping methods', { params: params });
                    isGuest = params.cartId;
                    if (!isGuest) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.$gemini.api.getAvailableShippingMethods({ cartId: params.cartId })];
                case 1:
                    data_1 = (_c.sent()).data;
                    Logger.debug('[Result]:', { data: data_1 });
                    hasAddresses_1 = data_1.cart.shipping_addresses.length > 0;
                    return [2 /*return*/, hasAddresses_1 ? data_1.cart.shipping_addresses[0].available_shipping_methods : []];
                case 2: return [4 /*yield*/, context.$gemini.api.getAvailableCustomerShippingMethods()];
                case 3:
                    data = (_c.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    hasAddresses = data.customerCart.shipping_addresses.length > 0;
                    return [2 /*return*/, hasAddresses ? (_b = (_a = data === null || data === void 0 ? void 0 : data.customerCart) === null || _a === void 0 ? void 0 : _a.shipping_addresses[0]) === null || _b === void 0 ? void 0 : _b.available_shipping_methods : []];
            }
        });
    }); },
};
var useGetShippingMethods = useGetShippingMethodsFactory(factoryParams$i);
var useGetShippingMethods$1 = useGetShippingMethods;

var useGuestUserFactory = function (factoryParams) { return function useGuestUser() {
    var _this = this;
    var errorsFactory = function () { return ({
        attachToCart: null,
    }); };
    var guestUser = sharedRef(null, 'useGuestUser-user');
    var loading = sharedRef(false, 'useGuestUser-loading');
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    var error = sharedRef(errorsFactory(), 'useGuestUser-error');
    var setGuestUser = function (newUser) {
        guestUser.value = newUser;
        Logger.debug('useGuestUserFactory.setGuestUser', newUser);
    };
    var resetErrorValue = function () {
        error.value = errorsFactory();
    };
    var attachToCart = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('useGuestUserFactory.attachToCart', { params: params });
                    resetErrorValue();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    _a = guestUser;
                    return [4 /*yield*/, _factoryParams.attachToCart(params)];
                case 2:
                    _a.value = _b.sent();
                    error.value.attachToCart = null;
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    error.value.attachToCart = err_1;
                    Logger.error('useGuestUser/attachToCart', err_1);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        setGuestUser: setGuestUser,
        attachToCart: attachToCart,
        guestUser: computed(function () { return guestUser.value; }),
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
    };
}; };

var factoryParams$h = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    attachToCart: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var infoOnCartInput, errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini]: Attach guest cart to user');
                    infoOnCartInput = {
                        email: params.email,
                        firstname: params.firstname,
                        lastname: params.lastname,
                        cart_id: context.cart.cart.value.id,
                    };
                    return [4 /*yield*/, context.$gemini.api.setGuestInfoOnCart(__assign({}, infoOnCartInput))];
                case 1:
                    errors = (_a.sent()).errors;
                    if (errors) {
                        throw new Error((errors.map(function (e) { return e.message; }).join(',')));
                    }
                    return [2 /*return*/];
            }
        });
    }); },
};
var index$9 = useGuestUserFactory(factoryParams$h);

var factoryParams$g = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    make: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var id, placeOrder, data, errors, err;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    Logger.debug('[Gemini] Make Order', { params: params });
                    id = context.cart.cart.value.id;
                    return [4 /*yield*/, context.$gemini.api.placeOrder({ cart_id: id })];
                case 1:
                    placeOrder = _c.sent();
                    data = placeOrder.data, errors = placeOrder.errors;
                    Logger.debug('[Result]:', { data: data });
                    Logger.debug('[Errors]:', { errors: errors });
                    if ((_a = data === null || data === void 0 ? void 0 : data.placeOrder) === null || _a === void 0 ? void 0 : _a.order) {
                        //@ts-ignore
                        return [2 /*return*/, (_b = data.placeOrder) === null || _b === void 0 ? void 0 : _b.order];
                    }
                    if (errors && errors.length > 0) {
                        err = new Error(errors[0].message);
                        err.name = "".concat(errors[0].extensions.code);
                        throw err;
                    }
                    else if (placeOrder) {
                        throw new Error("".concat(placeOrder));
                    }
                    else {
                        throw new Error('Unable to finalize order');
                    }
            }
        });
    }); },
};
var useMakeOrder = useMakeOrderFactory(factoryParams$g);
var useMakeOrder$1 = useMakeOrder;

var generateUserData = function (userData) {
    var baseData = {
        email: userData.email,
        firstname: userData.firstName || userData.firstname,
        lastname: userData.lastName || userData.lastname,
    };
    if (Object.prototype.hasOwnProperty.call(userData, 'is_subscribed')) {
        baseData.is_subscribed = userData.is_subscribed;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'dateOfBirth') || Object.prototype.hasOwnProperty.call(userData, 'date_of_birth')) {
        baseData.date_of_birth = userData.dateOfBirth || userData.date_of_birth;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'gender')) {
        baseData.gender = userData.gender;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'taxvat')) {
        baseData.taxvat = userData.taxvat;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'prefix')) {
        baseData.prefix = userData.prefix;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'suffix')) {
        baseData.suffix = userData.suffix;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'password')) {
        baseData.password = userData.password;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'phone_number')) {
        baseData.phone_number = userData.phone_number;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'taxCode') || Object.prototype.hasOwnProperty.call(userData, 'tax_code')) {
        baseData.tax_code = userData.taxCode || userData.tax_code;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'certifiedEmail') || Object.prototype.hasOwnProperty.call(userData, 'certified_email')) {
        baseData.certified_email = userData.certifiedEmail || userData.certified_email;
    }
    if (Object.prototype.hasOwnProperty.call(userData, 'consents')) {
        baseData.consents = userData.consents;
    }
    return baseData;
};

var factoryParams$f = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    load: function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var apiState, data;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    Logger.debug('[Gemini] Load user information');
                    apiState = context.$gemini.config.state;
                    if (!apiState.getCustomerToken()) {
                        return [2 /*return*/, null];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, context.$gemini.api.customer()];
                case 2:
                    data = (_d.sent()).data;
                    apiState.setSegments(apiState.getCustomerToken(), (_b = data.customer) === null || _b === void 0 ? void 0 : _b.segments);
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_c = data === null || data === void 0 ? void 0 : data.customer) !== null && _c !== void 0 ? _c : {}];
                case 3:
                    _d.sent();
                    // eslint-disable-next-line no-void
                    // @ts-ignore
                    return [4 /*yield*/, factoryParams$f.logOut(context)];
                case 4:
                    // eslint-disable-next-line no-void
                    // @ts-ignore
                    _d.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, null];
            }
        });
    }); },
    logOut: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var apiState;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiState = context.$gemini.config.state;
                    return [4 /*yield*/, context.$gemini.api.revokeCustomerToken(params)];
                case 1:
                    _a.sent();
                    apiState.setCustomerToken(null);
                    apiState.setCartId(null);
                    apiState.setSegments(null);
                    apiState.setWishlist(null);
                    context.cart.setCart(null);
                    return [2 /*return*/];
            }
        });
    }); },
    updateUser: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var oldEmail, _a, email, password, updateData, userData, updateEmailErrors, apiState, _b, data_1, authErrors, _c, data, updateErrors;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    Logger.debug('[Gemini] Update user information', { params: params });
                    oldEmail = params.currentUser.email;
                    _a = params.updatedUserData, email = _a.email, password = _a.password, updateData = __rest(_a, ["email", "password"]);
                    userData = generateUserData(updateData);
                    if (!(email && email !== oldEmail)) return [3 /*break*/, 3];
                    Logger.debug('[Gemini] Update user email', { params: params });
                    return [4 /*yield*/, context.$gemini.api.updateCustomerEmail({
                            email: email,
                            password: password,
                        })];
                case 1:
                    updateEmailErrors = (_e.sent()).errors;
                    if (updateEmailErrors) {
                        Logger.error(updateEmailErrors);
                        throw new Error(updateEmailErrors.map(function (e) { return e.message; }).join(','));
                    }
                    Logger.debug('[Gemini] Authenticate user');
                    apiState = context.$gemini.config.state;
                    return [4 /*yield*/, context.$gemini.api.generateCustomerToken({
                            email: email,
                            password: password,
                            recaptchaToken: '',
                        })];
                case 2:
                    _b = _e.sent(), data_1 = _b.data, authErrors = _b.errors;
                    Logger.debug('[Result]:', { data: data_1 });
                    if (authErrors) {
                        Logger.error(authErrors);
                        throw new Error(authErrors.map(function (e) { return e.message; }).join(','));
                    }
                    if (!data_1.generateCustomerToken || !data_1.generateCustomerToken.token) {
                        throw new Error('Customer sign-in error');
                    }
                    apiState.setCustomerToken(data_1.generateCustomerToken.token);
                    _e.label = 3;
                case 3: return [4 /*yield*/, context.$gemini.api.updateCustomer(userData)];
                case 4:
                    _c = _e.sent(), data = _c.data, updateErrors = _c.errors;
                    if (updateErrors) {
                        Logger.error(updateErrors);
                        throw new Error(updateErrors.map(function (e) { return e.message; }).join(','));
                    }
                    Logger.debug('[Result]:', { data: data });
                    // return data.updateCustomerV2.customer;
                    return [2 /*return*/, ((_d = data === null || data === void 0 ? void 0 : data.updateCustomerV2) === null || _d === void 0 ? void 0 : _d.customer) || {}];
            }
        });
    }); },
    register: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, email, password, baseData, _b, data, errors;
        var _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = generateUserData(params), email = _a.email, password = _a.password, baseData = __rest(_a, ["email", "password"]);
                    return [4 /*yield*/, context.$gemini.api.createCustomer(__assign({ email: email, password: password }, baseData))];
                case 1:
                    _b = _f.sent(), data = _b.data, errors = _b.errors;
                    Logger.debug('[Result]:', { data: data });
                    if (errors) {
                        Logger.error(errors);
                        throw new Error(errors.map(function (e) { return e.message; }).join(','));
                    }
                    if (!data.createCustomerV2 || !data.createCustomerV2.customer) {
                        throw new Error('Customer registration error');
                    }
                    if ((_e = (_d = (_c = context === null || context === void 0 ? void 0 : context.$gemini) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.recaptcha) === null || _e === void 0 ? void 0 : _e.isEnabled) {
                        return [2 /*return*/, factoryParams$f.logIn(context, {
                                username: email,
                                password: password,
                                isRegister: true,
                            })];
                    }
                    return [2 /*return*/, factoryParams$f.logIn(context, { username: email, password: password })];
            }
        });
    }); },
    logIn: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var apiState, _a, data, errors, currentCartId, cart, newCartId, dataMergeCart;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] Authenticate user');
                    apiState = context.$gemini.config.state;
                    return [4 /*yield*/, context.$gemini.api.generateCustomerToken({
                            email: params.username,
                            password: params.password,
                            recaptchaToken: params.recaptchaToken,
                            isRegister: params.isRegister,
                        })];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    Logger.debug('[Result]:', { data: data });
                    if (errors) {
                        Logger.error(errors);
                        throw new Error(errors.map(function (e) { return e.message; }).join(','));
                    }
                    if (!data.generateCustomerToken || !data.generateCustomerToken.token) {
                        throw new Error('Customer sign-in error');
                    }
                    apiState.setCustomerToken(data.generateCustomerToken.token);
                    apiState.setWishlist(null);
                    currentCartId = apiState.getCartId();
                    return [4 /*yield*/, context.$gemini.api.customerCart()];
                case 2:
                    cart = _b.sent();
                    newCartId = cart.data.customerCart.id;
                    if (!(newCartId && currentCartId && currentCartId !== newCartId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, context.$gemini.api.mergeCarts({
                            sourceCartId: currentCartId,
                            destinationCartId: newCartId,
                        })];
                case 3:
                    dataMergeCart = (_b.sent()).data;
                    context.cart.setCart(dataMergeCart.mergeCarts);
                    apiState.setCartId(dataMergeCart.mergeCarts.id);
                    return [3 /*break*/, 5];
                case 4:
                    context.cart.setCart(cart.data.customerCart);
                    _b.label = 5;
                case 5: return [2 /*return*/, factoryParams$f.load(context)];
            }
        });
    }); },
    changePassword: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] changing user password');
                    return [4 /*yield*/, context.$gemini.api.changeCustomerPassword(params)];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        Logger.error(errors);
                        throw new Error(errors.map(function (e) { return e.message; }).join(','));
                    }
                    Logger.debug('[Result] ', { data: data });
                    return [2 /*return*/, data === null || data === void 0 ? void 0 : data.changeCustomerPassword];
            }
        });
    }); },
};
var useUser = useUserFactory(factoryParams$f);

var useNewsletterFactory = function (factoryParams) { return function useNewsletter() {
    var _this = this;
    var errorsFactory = function () { return ({
        updateSubscription: null,
    }); };
    var loading = sharedRef(false, 'useNewsletter-loading');
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    var subscribeEmailToNewsletterStatus = sharedRef(false, "useNewsletter-updateSubscription-status");
    var error = sharedRef(errorsFactory(), 'useNewsletter-error');
    var resetErrorValue = function () {
        error.value = errorsFactory();
    };
    var updateSubscription = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var subscribeStatus, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('useNewsletterFactory.updateSubscription', params);
                    resetErrorValue();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.updateSubscription(params)];
                case 2:
                    subscribeStatus = _a.sent();
                    error.value.updateSubscription = null;
                    subscribeEmailToNewsletterStatus.value = subscribeStatus;
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    error.value.updateSubscription = err_1;
                    Logger.error('useNewsletter/updateSubscription', err_1);
                    subscribeEmailToNewsletterStatus.value = null;
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        subscribeEmailToNewsletterStatus: computed(function () { return subscribeEmailToNewsletterStatus.value; }),
        error: computed(function () { return error.value; }),
        loading: computed(function () { return loading.value; }),
        updateSubscription: updateSubscription,
    };
}; };

var factoryParams$e = {
    provide: function () {
        return {
            user: useUser(),
        };
    },
    updateSubscription: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini]: Update user newsletter subscription', { params: params });
                    return [4 /*yield*/, context.$gemini.api.subscribeEmailToNewsletter({
                            email: params.email,
                            name: params.name,
                            lastName: params.lastName,
                            birthdate: params.birthdate,
                            country: params.country,
                            gender: params.gender,
                        })];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.subscribeEmailToNewsletter) === null || _a === void 0 ? void 0 : _a.status];
            }
        });
    }); },
};
var index$8 = useNewsletterFactory(factoryParams$e);

var usePaymentProviderFactory = function (factoryParams) { return function usePaymentProvider() {
    var _this = this;
    var loading = sharedRef(false, 'usePaymentProvider-loading');
    var state = sharedRef(null, 'usePaymentProvider-response');
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    var error = sharedRef({
        load: null,
        save: null,
    }, 'usePaymentProvider-error');
    var setState = function (newState) {
        state.value = newState;
        Logger.debug('usePaymentProvider.setState', newState);
    };
    var save = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('usePaymentProvider.save');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.save({
                            paymentMethod: params.paymentMethod || {},
                            customQuery: (params === null || params === void 0 ? void 0 : params.customQuery) || {},
                            state: state,
                        })];
                case 2:
                    _a.sent();
                    error.value.save = null;
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    error.value.save = err_1;
                    Logger.error('usePaymentProvider/save', err_1);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var load = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _a, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('usePaymentProvider.load');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    _a = state;
                    return [4 /*yield*/, _factoryParams.load({
                            customQuery: (params === null || params === void 0 ? void 0 : params.customQuery) || {},
                            state: state,
                        })];
                case 2:
                    _a.value = _b.sent();
                    error.value.load = null;
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _b.sent();
                    error.value.load = err_2;
                    Logger.error('usePaymentProvider/load', err_2);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        state: state,
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
        load: load,
        save: save,
        setState: setState,
    };
}; };

var factoryParams$d = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    load: function (context, _a) {
        var customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var cartId, data, cartContainsVirtualProducts;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini] loadPaymentProvider', { customQuery: customQuery });
                        cartId = context.cart.cart.value.id;
                        return [4 /*yield*/, context
                                .$gemini
                                .api
                                .getAvailablePaymentMethods({ cartId: cartId })];
                    case 1:
                        data = (_b.sent()).data;
                        Logger.debug('[Result]:', { data: data });
                        cartContainsVirtualProducts = false;
                        context.cart.cart.value.items.forEach(function (item) {
                            if (item.product.is_virtual) {
                                cartContainsVirtualProducts = true;
                                Logger.debug('[Gemini] virtual product found in the cart, skip no upfront payment methods');
                            }
                        });
                        if (cartContainsVirtualProducts && Object.prototype.hasOwnProperty.call(data.cart, 'available_payment_methods')) {
                            data.cart.available_payment_methods.forEach(function (method, index) {
                                if (method.is_upfront === false) {
                                    delete data.cart.available_payment_methods[index];
                                    Logger.debug('[Gemini] removed available payment method because virtual product:', method.code);
                                }
                            });
                        }
                        return [2 /*return*/, data
                                .cart
                                .available_payment_methods];
                }
            });
        });
    },
    save: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var paymentMethodParams, data, cart;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini] savePaymentProvider', { params: params });
                    paymentMethodParams = {
                        cart_id: context.cart.cart.value.id,
                        payment_method: __assign({}, params.paymentMethod),
                    };
                    return [4 /*yield*/, context
                            .$gemini
                            .api
                            .setPaymentMethodOnCart(paymentMethodParams)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    cart = data
                        .setPaymentMethodOnCart.cart;
                    context.cart.setCart(cart);
                    return [2 /*return*/, data
                            .setPaymentMethodOnCart
                            .cart
                            .available_payment_methods];
            }
        });
    }); },
};
var index$7 = usePaymentProviderFactory(factoryParams$d);

var factoryParams$c = {
    // @ts-ignore
    productsSearch: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, queryType, customQuery, searchParams, _b, productDetailsResults, productListResults;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    Logger.debug('[Gemini]: Load product based on ', { params: params });
                    _a = __assign({}, params), queryType = _a.queryType, customQuery = _a.customQuery, searchParams = __rest(_a, ["queryType", "customQuery"]);
                    _b = queryType;
                    switch (_b) {
                        case "DETAIL" /* ProductsQueryType.Detail */: return [3 /*break*/, 1];
                        case "LIST" /* ProductsQueryType.List */: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, context
                        .$gemini
                        .api
                        .productDetail(__assign({}, searchParams), customQuery)];
                case 2:
                    productDetailsResults = _c.sent();
                    Logger.debug('[Result]:', { data: productDetailsResults });
                    return [2 /*return*/, { items: [productDetailsResults.data.productDetail] }];
                case 3: return [4 /*yield*/, context
                        .$gemini
                        .api
                        .products(searchParams, customQuery)];
                case 4:
                    productListResults = _c.sent();
                    Logger.debug('[Result]:', { data: productListResults });
                    return [2 /*return*/, productListResults.data.products];
            }
        });
    }); },
};
var useProduct = useProductFactory(factoryParams$c);
var useProduct$1 = useProduct;

function useRelatedProductsFactory(factoryParams) {
    return function useRelatedProduct(id) {
        var _this = this;
        var products = sharedRef([], "useRelatedProducts-products-".concat(id));
        var loading = sharedRef(false, "useRelatedProducts-loading-".concat(id));
        var error = sharedRef({
            search: null,
        }, "useRelatedProducts-error-".concat(id));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams, {
            mainRef: products, alias: 'relatedProducts-currentProduct',
            loading: loading,
            error: error,
        });
        var search = function (searchParams) { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useRelatedProducts/".concat(id, "/search"), searchParams);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        _a = products;
                        return [4 /*yield*/, _factoryParams.productsSearch(searchParams)];
                    case 2:
                        _a.value = _b.sent();
                        error.value.search = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        error.value.search = err_1;
                        Logger.error("useRelatedProducts/".concat(id, "/search"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            search: search,
            products: computed(function () { return products.value; }),
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$b = {
    productsSearch: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var searchParams, data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    Logger.debug('[Gemini] Load related products based on ', { params: params });
                    params.customQuery, searchParams = __rest(params, ["customQuery"]);
                    return [4 /*yield*/, context
                            .$gemini
                            .api
                            .relatedProduct(searchParams)];
                case 1:
                    data = (_c.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_b = (_a = data.products) === null || _a === void 0 ? void 0 : _a.items[0]) === null || _b === void 0 ? void 0 : _b.related_products];
            }
        });
    }); },
};
var useRelatedProducts = useRelatedProductsFactory(factoryParams$b);
var useRelatedProducts$1 = useRelatedProducts;

var factoryParams$a = {
    provide: function () {
        return {
            useGetShippingMethods: useGetShippingMethods$1(),
            cart: useCart(),
        };
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    load: function (context, _a) {
        var customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug('[Gemini] loadShipping', { customQuery: customQuery });
                        // workaround force to reload data
                        // if (!context.cart.cart?.value?.shipping_addresses || true) {
                        return [4 /*yield*/, context.cart.load({ customQuery: customQuery })];
                    case 1:
                        // workaround force to reload data
                        // if (!context.cart.cart?.value?.shipping_addresses || true) {
                        _b.sent();
                        // }
                        return [2 /*return*/, context.cart.cart.value.shipping_addresses[0]];
                }
            });
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    save: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var id, _a, apartment, neighborhood, extra, customerAddressId, address, shippingData, shippingAddressInput, _b, data, errors;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    Logger.debug('[Gemini] save user shipping address', { params: params });
                    id = context.cart.cart.value.id;
                    _a = params.shippingDetails, apartment = _a.apartment, neighborhood = _a.neighborhood, extra = _a.extra, customerAddressId = _a.customerAddressId, address = __rest(_a, ["apartment", "neighborhood", "extra", "customerAddressId"]);
                    shippingData = customerAddressId
                        ? ({
                            customer_address_id: customerAddressId,
                            address: __assign(__assign({}, address), { street: [address.street, apartment, neighborhood, extra] }),
                        })
                        : ({
                            address: __assign(__assign({}, address), { street: [address.street, apartment, neighborhood, extra] }),
                        });
                    shippingAddressInput = {
                        cart_id: id,
                        shipping_addresses: [
                            __assign({}, shippingData),
                        ],
                    };
                    return [4 /*yield*/, context
                            .$gemini
                            .api
                            .setShippingAddressesOnCart(shippingAddressInput)];
                case 1:
                    _b = _c.sent(), data = _b.data, errors = _b.errors;
                    if (errors && errors.length > 0) {
                        throw errors[0];
                    }
                    Logger.debug('[Result]:', { data: data });
                    context.useGetShippingMethods.setState(data
                        .setShippingAddressesOnCart
                        .cart
                        .shipping_addresses[0]
                        .available_shipping_methods);
                    return [2 /*return*/, data
                            .setShippingAddressesOnCart
                            .cart
                            .shipping_addresses[0]];
            }
        });
    }); },
};
var index$6 = useShippingFactory(factoryParams$a);

function useStoreFactory(factoryParams) {
    return function useStore(cacheId) {
        var _this = this;
        if (cacheId === void 0) { cacheId = ''; }
        var ssrKey = cacheId || 'useStoreFactory';
        // @ts-ignore
        var stores = sharedRef([], "".concat(ssrKey, "-stores"));
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        var load = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useStore/".concat(ssrKey, "/load"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = stores;
                        return [4 /*yield*/, _factoryParams.load(params)];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // eslint-disable-next-line @typescript-eslint/require-await
        var change = function (store) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                loading.value = true;
                try {
                    _factoryParams.change(store);
                }
                finally {
                    loading.value = false;
                }
                return [2 /*return*/];
            });
        }); };
        return {
            load: load,
            change: change,
            stores: computed(function () { return stores.value; }),
            loading: computed(function () { return loading.value; }),
        };
    };
}

var factoryParams$9 = {
    provide: function () {
        return {
            cart: useCart(),
        };
    },
    load: function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, context.$gemini.api.availableStores()];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.availableStores || []];
            }
        });
    }); },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    change: function (context, store) {
        context.$gemini.config.state.setStore(StoreConfigGetters.getCode(store));
        context.$gemini.config.state.setCurrency(StoreConfigGetters.getCurrency(store));
        context.$gemini.config.state.setLocale(StoreConfigGetters.getCode(store));
        // removed in the new version
        // context.cart.clear();
    },
};
var useStore = useStoreFactory(factoryParams$9);
var useStore$1 = useStore;

function useUpsellProductsFactory(factoryParams) {
    return function useUpsellProducts(id) {
        var _this = this;
        var products = sharedRef([], "useUpsellProducts-products-".concat(id));
        var loading = sharedRef(false, "useUpsellProducts-loading-".concat(id));
        var error = sharedRef({
            search: null,
        }, "useUpsellProducts-error-".concat(id));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams, {
            mainRef: products, alias: 'useUpsellProducts-currentProducts',
            loading: loading,
            error: error,
        });
        var search = function (searchParams) { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useUpsellProducts/".concat(id, "/search"), searchParams);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        _a = products;
                        return [4 /*yield*/, _factoryParams.productsSearch(searchParams)];
                    case 2:
                        _a.value = _b.sent();
                        error.value.search = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        error.value.search = err_1;
                        Logger.error("useUpsellProducts/".concat(id, "/search"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            search: search,
            products: computed(function () { return products.value; }),
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$8 = {
    productsSearch: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, searchParams, data;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    Logger.debug('[Gemini] Find upsell products based on ', { params: params });
                    _a = __assign({}, params), _a.customQuery, searchParams = __rest(_a, ["customQuery"]);
                    return [4 /*yield*/, context
                            .$gemini
                            .api
                            .upsellProduct(searchParams)];
                case 1:
                    data = (_d.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_c = (_b = data.products) === null || _b === void 0 ? void 0 : _b.items[0]) === null || _c === void 0 ? void 0 : _c.upsell_products];
            }
        });
    }); },
};
var useUpsellProducts = useUpsellProductsFactory(factoryParams$8);
var useUpsellProducts$1 = useUpsellProducts;

var useUrlResolverFactory = function (factoryParams) { return function useRouter(ssrKey) {
    var _this = this;
    if (ssrKey === void 0) { ssrKey = 'useRouter'; }
    // @ts-ignore
    var result = sharedRef({}, "".concat(ssrKey, "-result"));
    var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
    var error = sharedRef({
        search: null,
    }, "".concat(ssrKey, "-error"));
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    // eslint-disable-next-line consistent-return
    var search = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug("useRouter/".concat(ssrKey, "/search"));
                    loading.value = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, _factoryParams.search(params)];
                case 2:
                    data = _a.sent();
                    result.value = data;
                    return [2 /*return*/, data];
                case 3:
                    err_1 = _a.sent();
                    error.value.search = err_1;
                    Logger.error("useRouter/".concat(ssrKey, "/search"), err_1);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        search: search,
        result: computed(function () { return result.value; }),
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
    };
}; };

var factoryParams$7 = {
    search: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var clearUrl, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug('[Gemini] Find information based on URL', { params: params });
                    clearUrl = params.url.replace(/[a-z]+\/[cp|]\//gi, '');
                    return [4 /*yield*/, context.$gemini.api.urlResolver(clearUrl)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Gemini] information for URL:', { data: data });
                    return [2 /*return*/, data.urlResolver];
            }
        });
    }); },
};
var useUrlResolver = useUrlResolverFactory(factoryParams$7);
var useUrlResolver$1 = useUrlResolver;

var factoryParams$6 = {
    provide: function () {
        return {
            user: useUser(),
        };
    },
    addAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini]: add billing address', { params: params });
                    return [4 /*yield*/, context.$gemini.api.createCustomerAddress(transformUserCreateAddressInput(params))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.createCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    deleteAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] delete billing address', { params: params });
                    return [4 /*yield*/, context.$gemini.api.deleteCustomerAddress(String(params.address.id))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.deleteCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    updateAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] update billing address', { params: params });
                    return [4 /*yield*/, context.$gemini.api.updateCustomerAddress(transformUserUpdateAddressInput(params))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.updateCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    load: function (context, _params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    Logger.debug('[Gemini] load user address');
                    if (!!((_b = (_a = context.user.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.user.load()];
                case 1:
                    _d.sent();
                    _d.label = 2;
                case 2: return [2 /*return*/, (_c = context.user.user) === null || _c === void 0 ? void 0 : _c.value];
            }
        });
    }); },
    setDefaultAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] setDefaultAddress');
                    return [4 /*yield*/, context.$gemini.api.updateCustomerAddress(transformUserUpdateAddressInput(params))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.updateCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
};
var index$5 = useUserBillingFactory(factoryParams$6);

var factoryParams$5 = {
    provide: function () {
        return {
            user: useUser(),
        };
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchOrders: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var customQuery, data;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    Logger.debug('[Gemini] search user orders', { params: params });
                    customQuery = params.customQuery;
                    if (!!((_b = (_a = context.user.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.user.load()];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2: return [4 /*yield*/, context.$gemini.api.customerOrders(params, customQuery)];
                case 3:
                    data = (_e.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_d = (_c = data === null || data === void 0 ? void 0 : data.customer) === null || _c === void 0 ? void 0 : _c.orders) !== null && _d !== void 0 ? _d : {}];
            }
        });
    }); },
};
var index$4 = useUserOrderFactory(factoryParams$5);

var factoryParams$4 = {
    provide: function () {
        return {
            user: useUser(),
        };
    },
    addAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini]: add shipping address', { params: params });
                    return [4 /*yield*/, context.$gemini.api.createCustomerAddress(transformUserCreateAddressInput(params))];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.createCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    deleteAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] delete shipping address', { params: params });
                    return [4 /*yield*/, context.$gemini.api.deleteCustomerAddress(params.address.id)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.deleteCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    updateAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini] update shipping address', { params: params });
                    return [4 /*yield*/, context.$gemini.api.updateCustomerAddress(transformUserUpdateAddressInput(params))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.updateCustomerAddress) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    load: function (context, _params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    Logger.debug('[Gemini] load user address');
                    if (!!((_b = (_a = context.user.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.user.load()];
                case 1:
                    _d.sent();
                    _d.label = 2;
                case 2: return [2 /*return*/, (_c = context.user.user) === null || _c === void 0 ? void 0 : _c.value];
            }
        });
    }); },
    setDefaultAddress: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    Logger.debug('[Gemini] set default shipping address');
                    if (!!((_b = (_a = context.user.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.user.load()];
                case 1:
                    _d.sent();
                    _d.label = 2;
                case 2: return [4 /*yield*/, context.$gemini.api.updateCustomerAddress(transformUserUpdateAddressInput(__assign(__assign({}, params), { default_shipping: true })))];
                case 3:
                    data = (_d.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    if ((data === null || data === void 0 ? void 0 : data.updateCustomerAddress) && context.user.user) {
                        return [2 /*return*/, __assign(__assign({}, data.updateCustomerAddress), { addresses: context.user.user.value.addresses })];
                    }
                    return [2 /*return*/, (_c = data === null || data === void 0 ? void 0 : data.updateCustomerAddress) !== null && _c !== void 0 ? _c : {}];
            }
        });
    }); },
};
var index$3 = useUserShippingFactory(factoryParams$4);

var compareWishlistProduct = function (productA, productB) {
    var equalSku = (productA === null || productA === void 0 ? void 0 : productA.sku) === (productB === null || productB === void 0 ? void 0 : productB.sku);
    var equalUid = (productA === null || productA === void 0 ? void 0 : productA.uid) === (productB === null || productB === void 0 ? void 0 : productB.uid);
    return equalSku && equalUid;
};
var findItemOnWishlist = function (currentWishlist, product) {
    var _a, _b;
    var wishlist = Array.isArray(currentWishlist) ? currentWishlist[0] : currentWishlist;
    return (_b = (_a = wishlist === null || wishlist === void 0 ? void 0 : wishlist.items_v2) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.find(function (item) { return compareWishlistProduct(item.product, product); });
};

var useWishlistFactory = function (factoryParams) {
    return function (ssrKey) {
        if (ssrKey === void 0) { ssrKey = 'useWishlistFactory'; }
        var loading = sharedRef(false, "useWishlist-loading-".concat(ssrKey));
        var wishlist = sharedRef(null, "useWishlist-wishlist-".concat(ssrKey));
        var error = sharedRef({
            addItem: null,
            removeItem: null,
            load: null,
            clear: null,
        }, "useWishlist-error-".concat(ssrKey));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams, {
            mainRef: wishlist,
            alias: 'currentWishlist',
            loading: loading,
            error: error,
        });
        var addItem = function (_a) {
            var product = _a.product, quantity = _a.quantity, customQuery = _a.customQuery;
            return __awaiter(void 0, void 0, void 0, function () {
                var updatedWishlist, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            Logger.debug("useWishlist/".concat(ssrKey, "/addItem"), product, quantity);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            loading.value = true;
                            return [4 /*yield*/, _factoryParams.addItem({
                                    product: product,
                                    quantity: quantity,
                                    customQuery: customQuery,
                                })];
                        case 2:
                            updatedWishlist = _b.sent();
                            error.value.addItem = null;
                            wishlist.value = updatedWishlist;
                            return [3 /*break*/, 5];
                        case 3:
                            err_1 = _b.sent();
                            error.value.addItem = err_1;
                            Logger.error("useWishlist/".concat(ssrKey, "/addItem"), err_1);
                            return [3 /*break*/, 5];
                        case 4:
                            loading.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        var updateItem = function (_a) {
            var product = _a.product, quantity = _a.quantity, customQuery = _a.customQuery;
            return __awaiter(void 0, void 0, void 0, function () {
                var updatedWishlist, err_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            Logger.debug("useWishlist/".concat(ssrKey, "/updateItem"), product, quantity);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            loading.value = true;
                            return [4 /*yield*/, _factoryParams.updateItem({
                                    product: product,
                                    quantity: quantity,
                                    customQuery: customQuery,
                                })];
                        case 2:
                            updatedWishlist = _b.sent();
                            error.value.updateItem = null;
                            wishlist.value = updatedWishlist;
                            return [3 /*break*/, 5];
                        case 3:
                            err_2 = _b.sent();
                            error.value.updateItem = err_2;
                            Logger.error("useWishlist/".concat(ssrKey, "/updateItem"), err_2);
                            return [3 /*break*/, 5];
                        case 4:
                            loading.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        var removeItem = function (_a) {
            var product = _a.product, customQuery = _a.customQuery;
            return __awaiter(void 0, void 0, void 0, function () {
                var updatedWishlist, err_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            Logger.debug("useWishlist/".concat(ssrKey, "/removeItem"), product);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            loading.value = true;
                            return [4 /*yield*/, _factoryParams.removeItem({
                                    product: product,
                                    customQuery: customQuery,
                                })];
                        case 2:
                            updatedWishlist = _b.sent();
                            error.value.removeItem = null;
                            wishlist.value = updatedWishlist;
                            return [3 /*break*/, 5];
                        case 3:
                            err_3 = _b.sent();
                            error.value.removeItem = err_3;
                            Logger.error("useWishlist/".concat(ssrKey, "/removeItem"), err_3);
                            return [3 /*break*/, 5];
                        case 4:
                            loading.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        var load = function (params) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useWishlist/".concat(ssrKey, "/load"));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        _a = wishlist;
                        return [4 /*yield*/, _factoryParams.load(params)];
                    case 2:
                        _a.value = _b.sent();
                        error.value.load = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_4 = _b.sent();
                        error.value.load = err_4;
                        wishlist.value = null;
                        Logger.error("useWishlist/".concat(ssrKey, "/load"), err_4);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var clear = function () { return __awaiter(void 0, void 0, void 0, function () {
            var updatedWishlist, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Logger.debug("useWishlist/".concat(ssrKey, "/clear"));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.clear()];
                    case 2:
                        updatedWishlist = _a.sent();
                        error.value.clear = null;
                        wishlist.value = updatedWishlist;
                        return [3 /*break*/, 5];
                    case 3:
                        err_5 = _a.sent();
                        error.value.clear = err_5;
                        Logger.error("useWishlist/".concat(ssrKey, "/clear"), err_5);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var isInWishlist = function (_a) {
            var product = _a.product;
            Logger.debug("useWishlist/".concat(ssrKey, "/isInWishlist"), product);
            return _factoryParams.isInWishlist({
                product: product,
            });
        };
        var hasItemsInWishlist = function (_a) {
            var items = _a.items;
            Logger.debug("useWishlist/".concat(ssrKey, "/hasItemsInWishlist"), items);
            return _factoryParams.hasItemsInWishlist({
                items: items,
            });
        };
        var getProductWishlistMap = function (_a) {
            var product = _a.product;
            Logger.debug("useWishlist/".concat(ssrKey, "/getProductWishlistMap"), product);
            return _factoryParams.getProductWishlistMap({
                product: product,
            });
        };
        return {
            api: _factoryParams.api,
            wishlist: computed(function () { return wishlist.value; }),
            getProductWishlistMap: getProductWishlistMap,
            isInWishlist: isInWishlist,
            addItem: addItem,
            load: load,
            removeItem: removeItem,
            clear: clear,
            hasItemsInWishlist: hasItemsInWishlist,
            updateItem: updateItem,
            loading: computed(function () { return loading.value; }),
            error: computed(function () { return error.value; }),
        };
    };
};

var getProductWishlistMap = function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
    var product, apiState, wishlistUid, grnsToCheck, data, selectedProductGrn, wishlistItemDetails, selectedProductWishlistItem, mappedProduct;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                product = params.product;
                if (!product) {
                    Logger.debug('[Gemini Storefront]: useWishlist.getProductWishlistMap no product provided', params);
                    return [2 /*return*/, {}];
                }
                Logger.debug('[Gemini Storefront]: useWishlist.getProductWishlistMap params->', params);
                apiState = context.$gemini.config.state;
                wishlistUid = apiState.getWishlist();
                if (!wishlistUid) {
                    return [2 /*return*/, null];
                }
                grnsToCheck = __spreadArray(__spreadArray([], ((_b = (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.map(function (variant) { var _a; return (_a = variant.product) === null || _a === void 0 ? void 0 : _a.uid; })) !== null && _b !== void 0 ? _b : []), true), [product.uid], false);
                return [4 /*yield*/, context.$gemini.api.itemsInWishlist({
                        wishlistUid: wishlistUid,
                        items: grnsToCheck,
                    })];
            case 1:
                data = (_g.sent()).data;
                selectedProductGrn = product.variantGrn || ((_d = (_c = product.configurable_product_options_selection) === null || _c === void 0 ? void 0 : _c.variant) === null || _d === void 0 ? void 0 : _d.sku) || product.uid;
                wishlistItemDetails = (_f = (_e = data === null || data === void 0 ? void 0 : data.itemsInWishlist) === null || _e === void 0 ? void 0 : _e.find(function (p) { return p.product_id === selectedProductGrn; })) === null || _f === void 0 ? void 0 : _f.wishlist_ids;
                selectedProductWishlistItem = wishlistItemDetails === null || wishlistItemDetails === void 0 ? void 0 : wishlistItemDetails.find(function (w) { return w.wishlist_uid.split('::')[1] === wishlistUid; });
                mappedProduct = {};
                if (selectedProductWishlistItem) {
                    mappedProduct[selectedProductWishlistItem.wishlist_uid] = selectedProductWishlistItem.item_uid;
                }
                return [2 /*return*/, mappedProduct];
        }
    });
}); };
var factoryParams$3 = {
    provide: function () {
        return {
            user: useUser(),
        };
    },
    // @ts-ignore
    load: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var apiState, wishlistUid, queryParams, customQuery, data, queryParams, customQuery, data;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    Logger.debug('[Gemini Storefront]: useWishlist.load params->', params);
                    apiState = context.$gemini.config.state;
                    wishlistUid = apiState.getWishlist();
                    if (!apiState.getCustomerToken()) return [3 /*break*/, 2];
                    queryParams = {
                        wishlistUid: wishlistUid,
                        itemsPageSize: params === null || params === void 0 ? void 0 : params.pageSize,
                        itemsNextPageToken: params === null || params === void 0 ? void 0 : params.nextPageToken,
                    };
                    customQuery = params === null || params === void 0 ? void 0 : params.customQuery;
                    return [4 /*yield*/, context.$gemini.api.customerWishlist(queryParams, customQuery)];
                case 1:
                    data = (_f.sent()).data;
                    wishlistUid = (_b = (_a = data === null || data === void 0 ? void 0 : data.customer) === null || _a === void 0 ? void 0 : _a.wishlist) === null || _b === void 0 ? void 0 : _b.uid;
                    apiState.setWishlist(wishlistUid);
                    return [2 /*return*/, (_d = (_c = data === null || data === void 0 ? void 0 : data.customer) === null || _c === void 0 ? void 0 : _c.wishlist) !== null && _d !== void 0 ? _d : {}];
                case 2:
                    if (!wishlistUid) return [3 /*break*/, 4];
                    queryParams = {
                        wishlistUid: wishlistUid,
                        itemsPageSize: params === null || params === void 0 ? void 0 : params.pageSize,
                        itemsNextPageToken: params === null || params === void 0 ? void 0 : params.nextPageToken,
                    };
                    customQuery = params === null || params === void 0 ? void 0 : params.customQuery;
                    return [4 /*yield*/, context.$gemini.api.wishlist(queryParams, customQuery)];
                case 3:
                    data = (_f.sent()).data;
                    // TODO add error management
                    return [2 /*return*/, (_e = data === null || data === void 0 ? void 0 : data.wishlist) !== null && _e !== void 0 ? _e : {}];
                case 4: return [2 /*return*/, {}];
            }
        });
    }); },
    // @ts-ignore
    addItem: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var product, quantity, apiState, wishlistUid, data_1, variantGrn, data;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    product = params.product, quantity = params.quantity;
                    Logger.debug('[Gemini Storefront]: useWishlist.addItem params->', params);
                    apiState = context.$gemini.config.state;
                    wishlistUid = apiState.getWishlist();
                    if (!!wishlistUid) return [3 /*break*/, 2];
                    return [4 /*yield*/, context.$gemini.api.createWishlist()];
                case 1:
                    data_1 = (_e.sent()).data;
                    wishlistUid = (_a = data_1 === null || data_1 === void 0 ? void 0 : data_1.createWishlist) === null || _a === void 0 ? void 0 : _a.uid;
                    apiState.setWishlist(wishlistUid);
                    _e.label = 2;
                case 2:
                    variantGrn = (_c = (_b = product.configurable_product_options_selection) === null || _b === void 0 ? void 0 : _b.variant) === null || _c === void 0 ? void 0 : _c.sku;
                    return [4 /*yield*/, context.$gemini.api.addItemToWishlist({
                            wishlistUid: wishlistUid,
                            item: {
                                sku: variantGrn !== null && variantGrn !== void 0 ? variantGrn : product.uid,
                                quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
                            },
                        })];
                case 3:
                    data = (_e.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    // @ts-ignore
                    return [2 /*return*/, (_d = data === null || data === void 0 ? void 0 : data.addItemToWishlist) !== null && _d !== void 0 ? _d : {}];
            }
        });
    }); },
    // @ts-ignore
    updateItem: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var product, quantity, apiState, wishlistUid, wishlistsItemMap, itemGrn, itemId, data;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    product = params.product, quantity = params.quantity;
                    Logger.debug('[Gemini Storefront]: useWishlist.updateItem params->', params);
                    apiState = context.$gemini.config.state;
                    wishlistUid = apiState.getWishlist();
                    if (!wishlistUid) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getProductWishlistMap(context, { product: product })];
                case 1:
                    wishlistsItemMap = _d.sent();
                    itemGrn = wishlistsItemMap["grn:wishlist:wishlist::".concat(wishlistUid)];
                    if (!itemGrn) {
                        return [2 /*return*/];
                    }
                    itemId = (_b = (_a = itemGrn.split('::')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('/')[1];
                    if (!itemId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, context.$gemini.api.updateItemInWishlist({
                            wishlistUid: wishlistUid,
                            wishlistItem: {
                                wishlist_item_uid: itemId,
                                quantity: quantity,
                            },
                        })];
                case 2:
                    data = (_d.sent()).data;
                    Logger.debug('[Result] useWishlist.updateItem:', { data: data });
                    // eslint-disable-next-line consistent-return
                    return [2 /*return*/, (_c = data === null || data === void 0 ? void 0 : data.updateItemInWishlist) !== null && _c !== void 0 ? _c : {}];
            }
        });
    }); },
    // @ts-ignore
    removeItem: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var product, apiState, wishlistUid, wishlistsItemMap, itemGrn, itemId, data;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    product = params.product;
                    Logger.debug('[Gemini Storefront]: useWishlist.removeItem params->', params);
                    apiState = context.$gemini.config.state;
                    wishlistUid = apiState.getWishlist();
                    if (!wishlistUid) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getProductWishlistMap(context, { product: product })];
                case 1:
                    wishlistsItemMap = _d.sent();
                    itemGrn = wishlistsItemMap["grn:wishlist:wishlist::".concat(wishlistUid)];
                    if (!itemGrn) {
                        return [2 /*return*/];
                    }
                    itemId = (_b = (_a = itemGrn.split('::')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('/')[1];
                    if (!itemId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, context.$gemini.api.removeItemFromWishlist({
                            wishlistUid: wishlistUid,
                            wishlistItemUid: itemId,
                        })];
                case 2:
                    data = (_d.sent()).data;
                    Logger.debug('[Result] useWishlist.removeItem:', { data: data });
                    // eslint-disable-next-line consistent-return
                    return [2 /*return*/, (_c = data === null || data === void 0 ? void 0 : data.removeItemFromWishlist) !== null && _c !== void 0 ? _c : {}];
            }
        });
    }); },
    clear: function (_a) {
        _a.currentWishlist;
        return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
            return [2 /*return*/, ({})];
        }); });
    },
    isInWishlist: function (context, params) {
        var currentWishlist = params.currentWishlist, product = params.product;
        var wishlistProduct = findItemOnWishlist(currentWishlist, product);
        return !!((wishlistProduct === null || wishlistProduct === void 0 ? void 0 : wishlistProduct.id) && (wishlistProduct === null || wishlistProduct === void 0 ? void 0 : wishlistProduct.quantity));
    },
    hasItemsInWishlist: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var items, apiState, wishlistUid, data, inWishlist;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = params.items;
                    Logger.debug('[Gemini Storefront]: useWishlist.hasItemsInWishlist params->', params);
                    apiState = context.$gemini.config.state;
                    wishlistUid = apiState.getWishlist();
                    if (!wishlistUid) {
                        return [2 /*return*/, Object.fromEntries(items.map(function (item) { return [item, false]; }))];
                    }
                    return [4 /*yield*/, context.$gemini.api.itemsInWishlist({
                            wishlistUid: wishlistUid,
                            items: items,
                        })];
                case 1:
                    data = (_b.sent()).data;
                    inWishlist = (_a = data === null || data === void 0 ? void 0 : data.itemsInWishlist.map(function (item) { return item.product_id; })) !== null && _a !== void 0 ? _a : [];
                    // eslint-disable-next-line unicorn/prefer-object-from-entries
                    return [2 /*return*/, items.reduce(function (prev, item) {
                            // we are interested only in the parent id to check if it is in the wishlist
                            var parentId = item.split('/')[0];
                            if (!prev[parentId]) {
                                // eslint-disable-next-line no-param-reassign
                                prev[parentId] = inWishlist.includes(item);
                            }
                            return prev;
                        }, {})];
            }
        });
    }); },
    getProductWishlistMap: getProductWishlistMap,
};
var index$2 = useWishlistFactory(factoryParams$3);

function useMenuFactory(factoryParams) {
    return function useMenu(ssrKey) {
        var _this = this;
        if (ssrKey === void 0) { ssrKey = 'useMenuFactory'; }
        // @ts-ignore
        var menu = sharedRef({}, "".concat(ssrKey, "-menu"));
        var loading = sharedRef(false, "".concat(ssrKey, "-menu-loading"));
        var error = sharedRef({ search: null }, "".concat(ssrKey, "-menu-error"));
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        var _factoryParams = configureFactoryParams(factoryParams);
        var search = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useMenu/".concat(ssrKey, "/search"));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        _a = menu;
                        return [4 /*yield*/, _factoryParams.search(params)];
                    case 2:
                        _a.value = _b.sent();
                        error.value.search = null;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        error.value.search = err_1;
                        Logger.error("useMenu/".concat(ssrKey, "/search"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return {
            api: _factoryParams.api,
            search: search,
            loading: computed(function () { return loading.value; }),
            menu: computed(function () { return menu.value; }),
            error: computed(function () { return error.value; }),
        };
    };
}

var factoryParams$2 = {
    search: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var filter, _a, data, errors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Logger.debug('[Gemini]: Load Menu', { params: params });
                    filter = {};
                    if (params.id)
                        filter.uid = params.id;
                    if (params.code)
                        filter.code = params.code;
                    return [4 /*yield*/, context.$gemini.api.menu(filter)];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        errors.forEach(function (error) {
                            Logger.error("".concat(error.extensions.code, " - ").concat(error.message));
                        });
                        // eslint-disable-next-line @typescript-eslint/no-throw-literal
                        throw errors;
                    }
                    Logger.debug('[Gemini]: Menu result', data);
                    return [2 /*return*/, data.menu];
            }
        });
    }); },
};
var index$1 = useMenuFactory(factoryParams$2);

function useMarketsFactory(factoryParams) {
    return function useMarkets(cacheId) {
        var _this = this;
        if (cacheId === void 0) { cacheId = ''; }
        var ssrKey = cacheId || 'useMarketsFactory';
        var markets = sharedRef([], "".concat(ssrKey, "-markets"));
        var loading = sharedRef(false, "".concat(ssrKey, "-loading"));
        var _factoryParams = configureFactoryParams(factoryParams);
        var load = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useStore/".concat(ssrKey, "/load"));
                        loading.value = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = markets;
                        return [4 /*yield*/, _factoryParams.load(params)];
                    case 2:
                        _a.value = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var change = function (market) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                loading.value = true;
                try {
                    _factoryParams.change(market);
                }
                finally {
                    loading.value = false;
                }
                return [2 /*return*/];
            });
        }); };
        return {
            load: load,
            change: change,
            markets: computed(function () { return markets.value; }),
            loading: computed(function () { return loading.value; })
        };
    };
}

var factoryParams$1 = {
    load: function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, context.$gemini.api.listMarkets()];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.listMarkets || []];
            }
        });
    }); },
    change: function (context, market) {
        context.$gemini.config.state.setMarket(market.grn);
    }
};
var useMarkets = useMarketsFactory(factoryParams$1);
var useMarkets$1 = useMarkets;

var useReturnFactory = function (factoryParams) { return function (ssrKey) {
    if (ssrKey === void 0) { ssrKey = 'useReturnFactory'; }
    var loading = sharedRef(false, "useReturn-loading-".concat(ssrKey));
    var rma = sharedRef(null, "useReturn-rma-".concat(ssrKey));
    var rmaList = sharedRef(null, "useReturn-rmaList-".concat(ssrKey));
    var rmaNote = sharedRef(null, "useReturn-rmaNote-".concat(ssrKey));
    var rmaCancellationResult = sharedRef(false, "useReturn-rmaCancellationResult-".concat(ssrKey));
    var error = sharedRef({
        createReturn: null,
        cancelReturn: null,
        getReturn: null,
        listReturns: null,
        addNote: null,
    }, "useReturn-error-".concat(ssrKey));
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    var _factoryParams = configureFactoryParams(factoryParams);
    var createReturn = function (_a) {
        var customer_info = _a.customer_info, note = _a.note, order_grn = _a.order_grn, preferred_refund_method = _a.preferred_refund_method, products = _a.products, refund_payment_cost = _a.refund_payment_cost, refund_shipping_cost = _a.refund_shipping_cost, return_address = _a.return_address, customQuery = _a.customQuery;
        return __awaiter(void 0, void 0, void 0, function () {
            var createdReturn, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Logger.debug("useReturn/".concat(ssrKey, "/createReturn"), order_grn);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        loading.value = true;
                        return [4 /*yield*/, _factoryParams.createReturn({
                                customer_info: customer_info,
                                note: note,
                                order_grn: order_grn,
                                preferred_refund_method: preferred_refund_method,
                                products: products,
                                refund_payment_cost: refund_payment_cost,
                                refund_shipping_cost: refund_shipping_cost,
                                return_address: return_address,
                                customQuery: customQuery,
                            })];
                    case 2:
                        createdReturn = _b.sent();
                        error.value.createReturn = null;
                        rma.value = createdReturn;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        error.value.createReturn = err_1;
                        Logger.error("useReturn/".concat(ssrKey, "/createReturn"), err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        loading.value = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var cancelReturn = function (returnUid) { return __awaiter(void 0, void 0, void 0, function () {
        var canceledReturn, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug("useReturn/".concat(ssrKey, "/cancelReturn"), returnUid);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.cancelReturn({ returnUid: returnUid })];
                case 2:
                    canceledReturn = _a.sent();
                    error.value.cancelReturn = null;
                    rmaCancellationResult.value = !!canceledReturn;
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    error.value.cancelReturn = err_2;
                    Logger.error("useReturn/".concat(ssrKey, "/cancelReturn"), err_2);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getReturn = function (returnUid) { return __awaiter(void 0, void 0, void 0, function () {
        var retrievedReturn, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug("useReturn/".concat(ssrKey, "/getReturn"), returnUid);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.getReturn({ returnUid: returnUid })];
                case 2:
                    retrievedReturn = _a.sent();
                    error.value.getReturn = null;
                    rma.value = retrievedReturn;
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _a.sent();
                    error.value.getReturn = err_3;
                    Logger.error("useReturn/".concat(ssrKey, "/getReturn"), err_3);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var listReturns = function (searchParams) { return __awaiter(void 0, void 0, void 0, function () {
        var retrievedRmas, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug("useReturn/".concat(ssrKey, "/listReturns"), searchParams);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.listReturns(searchParams)];
                case 2:
                    retrievedRmas = _a.sent();
                    error.value.listReturns = null;
                    rmaList.value = retrievedRmas;
                    return [3 /*break*/, 5];
                case 3:
                    err_4 = _a.sent();
                    error.value.listReturns = err_4;
                    Logger.error("useReturn/".concat(ssrKey, "/listReturns"), err_4);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var addNote = function (addNoteParams) { return __awaiter(void 0, void 0, void 0, function () {
        var addedNote, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Logger.debug("useReturn/".concat(ssrKey, "/addNote"), addNoteParams);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    loading.value = true;
                    return [4 /*yield*/, _factoryParams.addNote(addNoteParams)];
                case 2:
                    addedNote = _a.sent();
                    error.value.addNote = null;
                    rmaNote.value = addedNote;
                    return [3 /*break*/, 5];
                case 3:
                    err_5 = _a.sent();
                    error.value.addNote = err_5;
                    Logger.error("useReturn/".concat(ssrKey, "/addNote"), err_5);
                    return [3 /*break*/, 5];
                case 4:
                    loading.value = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        api: _factoryParams.api,
        rma: computed(function () { return rma.value; }),
        rmaNote: computed(function () { return rmaNote.value; }),
        rmaList: computed(function () { return rmaList.value; }),
        loading: computed(function () { return loading.value; }),
        error: computed(function () { return error.value; }),
        rmaCancellationResult: computed(function () { return rmaCancellationResult.value; }),
        createReturn: createReturn,
        cancelReturn: cancelReturn,
        getReturn: getReturn,
        listReturns: listReturns,
        addNote: addNote,
    };
}; };

var factoryParams = {
    // @ts-ignore
    createReturn: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var createReturnInput, data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params.customQuery, createReturnInput = __rest(params, ["customQuery"]);
                    createReturnInput.preferred_refund_method = RefundMethod.RefundMethodOffline; // Online Refunds are not implemented yet
                    // defaulting in case frontend doesn't pass this
                    if (!createReturnInput.refund_payment_cost)
                        createReturnInput.refund_payment_cost = true;
                    if (!createReturnInput.refund_shipping_cost)
                        createReturnInput.refund_shipping_cost = true;
                    Logger.debug('[Gemini Storefront]: useReturn.createReturn params->', params);
                    return [4 /*yield*/, context.$gemini.api.createReturn({ createReturnInput: createReturnInput })];
                case 1:
                    data = (_b.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    // @ts-ignore
                    return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.rma) !== null && _a !== void 0 ? _a : {}];
            }
        });
    }); },
    cancelReturn: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var returnUid, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params.customQuery, returnUid = __rest(params, ["customQuery"]);
                    Logger.debug('[Gemini Storefront]: useReturn.cancelReturn params->', params);
                    return [4 /*yield*/, context.$gemini.api.cancelReturn(returnUid)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data === null || data === void 0 ? void 0 : data.cancelReturn];
            }
        });
    }); },
    getReturn: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var returnUid, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params.customQuery, returnUid = __rest(params, ["customQuery"]);
                    Logger.debug('[Gemini Storefront]: useReturn.getReturn params->', params);
                    return [4 /*yield*/, context.$gemini.api.getReturn(returnUid)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    return [2 /*return*/, data === null || data === void 0 ? void 0 : data.getReturn];
            }
        });
    }); },
    listReturns: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var searchParams, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params.customQuery, searchParams = __rest(params, ["customQuery"]);
                    Logger.debug('[Gemini Storefront]: useReturn.listReturns params->', params);
                    return [4 /*yield*/, context.$gemini.api.listReturns(searchParams)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    // @ts-ignore
                    return [2 /*return*/, data === null || data === void 0 ? void 0 : data.listReturns];
            }
        });
    }); },
    addNote: function (context, params) { return __awaiter(void 0, void 0, void 0, function () {
        var addNoteParams, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params.customQuery, addNoteParams = __rest(params, ["customQuery"]);
                    Logger.debug('[Gemini Storefront]: useReturn.addNote params->', addNoteParams);
                    return [4 /*yield*/, context.$gemini.api.addNote(addNoteParams)];
                case 1:
                    data = (_a.sent()).data;
                    Logger.debug('[Result]:', { data: data });
                    // @ts-ignore
                    return [2 /*return*/, data === null || data === void 0 ? void 0 : data.addNote];
            }
        });
    }); },
};
var index = useReturnFactory(factoryParams);

/* istanbul ignore file */
track('VSFGemini');

export { addressGetter, cartGetters$1 as cartGetters, categoryGetters$1 as categoryGetters, checkoutGetters$1 as checkoutGetters, contentGetters$1 as contentGetters, extendScopeContext, facetGetters$1 as facetGetters, forgotPasswordGetters$1 as forgotPasswordGetters, orderGetters$1 as orderGetters, productGetters$1 as productGetters, StoreConfigGetters as storeConfigGetters, storeGetters$1 as storeGetters, index$h as useAddresses, index$g as useBilling, useCart, index$f as useCategory, useCategorySearch$1 as useCategorySearch, useConfig$1 as useConfig, index$e as useContent, useCountrySearch$1 as useCountrySearch, useCurrency$1 as useCurrency, index$d as useCustomMutation, index$c as useCustomQuery, index$b as useExternalCheckout, index$a as useFacet, useForgotPassword$1 as useForgotPassword, useGetShippingMethods$1 as useGetShippingMethods, index$9 as useGuestUser, useMakeOrder$1 as useMakeOrder, useMarkets$1 as useMarkets, index$1 as useMenu, index$8 as useNewsletter, index$7 as usePaymentProvider, useProduct$1 as useProduct, useRelatedProducts$1 as useRelatedProducts, index as useReturn, index$6 as useShipping, useShippingProvider, useStore$1 as useStore, useUpsellProducts$1 as useUpsellProducts, useUrlResolver$1 as useUrlResolver, useUser, index$5 as useUserBilling, index$4 as useUserOrder, index$3 as useUserShipping, index$2 as useWishlist, userAddressesGetters$1 as userAddressesGetters, userBillingGetters$1 as userBillingGetters, userGetters$1 as userGetters, userShippingGetters$1 as userShippingGetters, wishlistGetters$1 as wishlistGetters };
//# sourceMappingURL=index.es.js.map
